import { Injectable } from "@angular/core";
import { Endpoints } from "../../../config/endpoints.config";
import { HttpClient } from "@angular/common/http";
import { DynamicForm, ControlDataType, LookupQuery, LookupSearchResult, Option, Control, FormType, DisplayText, BusinessProcessType, SubgridLayout, BusinessLineVal, MDM_USER_TYPE, FormChangeRequestType, OTHER_LOOKUP_OPTION_ID } from "../../classes/dynamic-form/dynamic-form.class";
import { capturesTyping, isOptionValueSet, selectedOptionValues } from './dynamic-form-values';
import { FormFieldType } from "../../models/indFormFieldDataModel";
import { DynamicsClientService } from "../../data-services/dynamics-client/dynamics-client.service";
import { IndDropdownListDetailModel } from "../../models/indDropdownListModel";
import { SelectListData } from "../../components/popover/popover";
import { Observable, Subject } from "rxjs";
import { debounceTime, map } from "rxjs/operators";
import { DB_KEY_PREFIXES } from "../../config/pouch-db.config";
import { DiskService } from "../disk/disk.service";
import { AuthenticationService } from "../authentication.service";
import { MOBILE_FORMS_FETCHXML, MOBILE_FORMS_DELTA, MOBILE_FORMS_ID_FILTER, MOBILE_FORMS_BUSINESS_RULES } from "../../config/dynamic-forms/dynamic-forms-fetchxml";
import { fetchQueries } from "../../config/dynamics-fetchQueries";
import { DynamicFormType } from '@omni/models/dynamic-form-component.model';
import { TranslateService } from '@ngx-translate/core';
import { EntityNameForTranslation, LocalizationService } from '../localization/localization.service';
import { ACCOUNT_ACCOUNT_AFFILIATIONS_CR_REF_ENTITY, ACCOUNT_ACCOUNT_AFFILIATIONS_REF_ENTITY, ACCOUNT_ACCOUNT_AFFILIATIONS_VIEW_ID,
         ACCOUNT_ACCOUNT_FROM_CR_ATTRIBUTE_NAME, ACCOUNT_ACCOUNT_FROM_FILTER_ATTRIBUTE_NAME, ACCOUNT_ACCOUNT_TO_CR_ATTRIBUTE_NAME,
         ACCOUNT_ACCOUNT_TO_FILTER_ATTRIBUTE_NAME, ACCOUNT_CONTACT_AFFILIATIONS_VIEW_ID, CONTACT_ACCOUNT_AFFILIATIONS_VIEW_ID,
         CONTACT_CONTACT_AFFILIATIONS_CR_REF_ENTITY, CONTACT_CONTACT_AFFILIATIONS_REF_ENTITY, CONTACT_CONTACT_AFFILIATIONS_VIEW_ID,
         CONTACT_CONTACT_FROM_CR_ATTRIBUTE_NAME, CONTACT_CONTACT_FROM_FILTER_ATTRIBUTE_NAME, CONTACT_CONTACT_TO_CR_ATTRIBUTE_NAME,
         CONTACT_CONTACT_TO_FILTER_ATTRIBUTE_NAME } from "../../config/dynamic-forms/affiliations-contants";
import { AffiliationsFilters } from "../../interfaces/dynamic-form/display-form.interface";
import { DEFAULT_CONTACT_CREATE_FORM, multilingualLanguageToAttributeMapping } from '@omni/config/dynamic-forms/default-contact/default-contact-create';
import { OmniAccordionViewDataModel } from "@omni/models/omniAccordionViewDataModel";
import { IndDisplayFormAffiliationViewDataModel } from "@omni/interfaces/dynamic-form/ind-display-form-affiliation-view-data.interface";
import { DateTimeFormatsService } from "../date-time-formats/date-time-formats.service";
import { NotificationService, ToastStyle } from "../notification/notification.service";
import { LoadingController } from "@ionic/angular";
import { DeltaService } from '@omni/data-services/delta/delta.service';
import { FeatureActionsMap } from '@omni/classes/authentication/user.class';
import { DEFAULT_FORM_LANGUAGE_CODE } from "@omni/components/shared/ind-display-form/ind-display-form.constants";
import { DynamicsConstant } from "@omni/utility/util";
import { deburr, escape, escapeRegExp, filter, intersectionBy, isArray, isEmpty } from 'lodash-es';
// import { ContactOfflineService } from "../contact/contact.service";


@Injectable({
  providedIn: 'root'
})
export class DynamicFormsService {

  // public tabs: any[] = [];
  // public sections: Section[] = [];
  // public formFieldAttributes: any[] = [];

  private dynamicForms = [];
  public contactCreateForm: DynamicForm;
  public metadata: any;

  public searchResultsObs$: Observable<any>;
  public searchParamsSub = new Subject();

  public lookupSearchData:Array<LookupSearchResult>= [];
  public lookupSearchInProgress:boolean = false;
  private islookupSearchMultilingualData: boolean =false;

  public linkedEntityFormIsDirtyTracker:boolean = false;

  /** Cached option sets for medical inquiry form (picklists without embedded options). Used for offline form hydration. */
  private miFormOptionSets: Record<string, Option[]> = {};

  /** Cached lookup results for MI form lookup fields (entities not already in PouchDB). Used for offline form. */
  private miFormLookupFields: Record<string, LookupSearchResult[]> = {};

  /** Entity set names already synced to PouchDB; skip caching these in syncLookupFieldsForMedicalInquiry. */
  private static readonly SKIP_ENTITIES = new Set([
    'contacts', 'accounts', 'products', 'indskr_products'
  ]);

  public isSelectedDataFromSearch: boolean = false;
  public isSelectedDataFromAddressOneKey: boolean = false;
  public isSearchedAddress: boolean = true;
  public storedLinkedEntityValues = [];
  public numOfLinkedEntity: {
    [x: string]: number
  };

  public mdmId: string;

  //Default Link Entity
  public contactDefaultLinkEntity = [
    "indskr_indskr_customeraddress_v2",
    "indskr_email_address",
    "indskr_accountcontactaffiliation",
  ]

  // Address auto-populated
  public selectedCountry: any;
  public selectedCity: any;
  public lookupSearchDataForCityBasedOnCountry: Array<LookupSearchResult>= [];
  public hasCityDataBasedOnCountry: boolean = false;
  public isSelectedCountry: boolean = false; // for checking mandatory field in Address CR
  public addressAttributeName: string;
  public accountAffiliationAttributeName: string;
  // Track affiliated Contact from Account
  public isNavAffiliatedContactFromAccount: boolean = false;
  public isOpenedAffiliatedContactOnAccount: boolean = false;
  public isOpenedAffiliatedContactOnContact: boolean = false;
  public isOpenedAffiliatedAccountOnContact: boolean = false;
  public isOpenedAffiliatedAccountOnAccount: boolean = false;
  public openedUnmappedData: boolean = false;
  public okAddressMapper: any = {};
  public okCRMapper: any = {};
  public okLookUpMapper: any = [];
  public removedCustomerPositionForRealignment: string = null;
  //Custom label for A-A/C-C affiliation
  public accountAffiliatedFromLabelText: string;
  public accountAffiliatedToLabelText: string;
  public contactAffiliatedFromLabelText: string;
  public contactAffiliatedToLabelText: string;
  public accountCrAffiliatedFromLabelText: string;
  public accountCrAffiliatedToLabelText: string;
  public contactCrAffiliatedFromLabelText: string;
  public contactCrAffiliatedToLabelText: string;

  /*************Edit business information in offline - Non-OneKey contacts*************/
  public allLookUpFieldsForOfflineEdit: any = {};
  /*************Edit business information in offline - Non-OneKey contacts*************/

  public affiliatedContacts: any[] = [];
  public targetContactIds: any[] = [];

  //Specific For Linked Entity Business Rules Implementation
  private currentLinkedEntityName:string;
  private currentLinkedEntityForm:DynamicForm;
  private currentLinkedEntityRawData:any;
  private currentLinkedEntitySubgridLayout:Array<SubgridLayout>;
  private subgridLayoutChangeAfterBusinessRules:boolean = false;
  
  constructor(
      private http: HttpClient,
      private dynamics: DynamicsClientService,
      private disk: DiskService,
      private authenticationService: AuthenticationService,
      public translate : TranslateService,
      public localizationService: LocalizationService,
      private notificationService: NotificationService,
      private loadingController: LoadingController,
      private deltaService: DeltaService,
      // private contactService: ContactOfflineService,
      private dateTimeFormatsService: DateTimeFormatsService,
  ) {}


  public async getDynamicForms(isFullSync, loadFromDbOnly = false) {

    let offlineDocs;
    let lastModifiedForDeltaSync, hourDifference;
    let now = new Date();

    await this.disk.retrieve(DB_KEY_PREFIXES.DYNAMIC_FORM, true).then((doc)=>{
      offlineDocs = doc
        if(doc && doc.raw){
          this.dynamicForms = doc.raw
        }
        else {
          this.dynamicForms = [];
          isFullSync = true;
        }
      })

    if(!loadFromDbOnly) {
      let fetchXML = MOBILE_FORMS_FETCHXML;
      if(isFullSync) {
        fetchXML = fetchXML.replace('{0}', this.authenticationService.user.systemUserID);
        fetchXML = fetchXML.replace('{BUID}', this.authenticationService.user.xBusinessUnitId);
        fetchXML = fetchXML.replace('{IdCondition}', '');
      }
      else {
        fetchXML = MOBILE_FORMS_DELTA;
        let deltaSyncFilter;
        lastModifiedForDeltaSync = offlineDocs ? offlineDocs.lastDeltaSync : null;
        if(lastModifiedForDeltaSync){
          hourDifference = this.dateTimeFormatsService.getDifferenceInHours(
            now,
            new Date(lastModifiedForDeltaSync)
          )
          //add one to make sure we take care of fractional difference in hours
          hourDifference += 1;
          const entityname = 'indskr_mobileappform';
          deltaSyncFilter = fetchQueries.deltaSyncFilter.replace('{entityName}', entityname);
          deltaSyncFilter = deltaSyncFilter.replace('{hourDifference}', hourDifference);
          deltaSyncFilter = deltaSyncFilter.replace('{entityID}', entityname + 'id');
        }
        else deltaSyncFilter = ''
        fetchXML = fetchXML.replace('{DeltaSyncFilter}', deltaSyncFilter);
      }

      try {
        let response = await this.dynamics.executeFetchQuery('indskr_mobileappforms', fetchXML);
        if(response){
          if(Array.isArray(response) && response.length != 0){
            if(isFullSync){
              let data = this.agreegateDynamicFormsResponse(response);
              //Fetch Business Rules
              await this.getBusineesRulesForMobileAppForms(data);
              if(data){
                await this.saveFormsDefinitionToOfflineDB(data, offlineDocs, isFullSync, now);
              }
            }else{
              await this.saveFormsDefinitionToOfflineDB(response, offlineDocs, isFullSync, now);
            }
          }
        }
      } catch(error) {
        console.log("Error fetching form metadata: ", error)
      }
    }
    else {
    }
  }

  private agreegateDynamicFormsResponse(rawData:Array<any>):Array<any>{
    let result:Array<any> = [];
    if(!rawData || (rawData && rawData.length <= 0)) return result;
    for(var i=0;i<rawData.length;i++){
      const item = rawData[i];
      if(!item) continue;
      const idx  = result.findIndex(a=> a.hasOwnProperty('indskr_mobileappformid') && item.hasOwnProperty('indskr_mobileappformid') && a.indskr_mobileappformid == item.indskr_mobileappformid);
      if(idx >= 0){
        if(item['indskr_searchentity.indskr_searchentityid']){
          let searchEntity = {
            indskr_searchentityid: item['indskr_searchentity.indskr_searchentityid'],
            indskr_attribute: item['indskr_searchentity.indskr_attribute'],
            indskr_relatedentity: item['indskr_searchentity.indskr_relatedentity']
          };
          result[idx].search_entities.push(searchEntity);
        }
        if(item['indskr_linkedentityformconfigurations.indskr_linkedentityformconfigurationsid'] &&
          result[idx].search_entities.indskr_linkedentityformconfigurationsid !== item['indskr_linkedentityformconfigurations.indskr_linkedentityformconfigurationsid']){
          let linkedEntities = {
            indskr_entityname: item['indskr_linkedentityformconfigurations.indskr_entityname'],
            indskr_linkedentityformconfigurationsid: item['indskr_linkedentityformconfigurations.indskr_linkedentityformconfigurationsid'],
            indskr_maximumnumberofrecordsallowed: item['indskr_linkedentityformconfigurations.indskr_maximumnumberofrecordsallowed'],
            indskr_minimumnumberofrecordsallowed: item['indskr_linkedentityformconfigurations.indskr_minimumnumberofrecordsallowed'],
            indskr_requirementtype: item['indskr_linkedentityformconfigurations.indskr_requirementtype'],
            indskr_abilitytoremoverecords: item['indskr_linkedentityformconfigurations.indskr_abilitytoremoverecords'],
            linkedEntitiesFieldConfig: []
          };
          result[idx].linked_entities_config.push(linkedEntities);
        }
        if(item['indskr_mobileappformfield.indskr_mobileappformfieldid']){
          let mandatoryFieldConfig = {
            indskr_mobileappformid: item['indskr_mobileappformfield.indskr_mobileappformid'],
            indskr_mobileappformfieldid: item['indskr_mobileappformfield.indskr_mobileappformfieldid'],
            indskr_mobileappformfieldname: item['indskr_mobileappformfield.indskr_mobileappformfieldname'],
            indskr_isrequired: item['indskr_mobileappformfield.indskr_isrequired'],
            indskr_filterby: item['indskr_mobileappformfield.indskr_filterby'],
            indskr_targetentityfilterfield: item['indskr_mobileappformfield.indskr_targetentityfilterfield'],
            indskr_target_entity_attribute: item['indskr_mobileappformfield.indskr_target_entity_attribute'],
            indskr_operatortype: item['indskr_mobileappformfield.indskr_operatortype'],
            indskr_viewtype: item['indskr_mobileappformfield.indskr_viewtype']
          };
          result[idx].mandatory_field_config.push(mandatoryFieldConfig);
        }
        if(item['indskr_editconfig']){
          result[idx].indskr_editconfig = item['indskr_editconfig'];
        }
        if (item['indskr_changerequesttype']) {
          result[idx].indskr_changerequesttype = item['indskr_changerequesttype'];
        }
      }else if(item.hasOwnProperty('indskr_mobileappformid') && item.indskr_mobileappformid){
        let formObj = {
          indskr_businessprocess: item['indskr_businessprocess'],
          indskr_formid: item['indskr_formid'],
          indskr_name: item['indskr_name'],
          indskr_entityname: item['indskr_entityname'],
          indskr_mdmusertype: item['indskr_mdmusertype'],
          statecode: item['statecode'],
          statuscode: item['statuscode'],
          versionnumber: item['versionnumber'],
          indskr_mobileappformid: item['indskr_mobileappformid'],
          modifiedon: item['modifiedon'],
          _owningbusinessunit_value: item['_owningbusinessunit_value'],
          _ownerid_value: item['_ownerid_value'],
          indskr_metadata: item['indskr_metadata'],
          indskr_formtype: item['indskr_formtype'],
          indskr_editconfig: item['indskr_editconfig'],
          search_entities: [],
          linked_entities_config: [],
          mandatory_field_config: [],
          indskr_changerequesttype: item['indskr_changerequesttype'],
          indskr_changerequestcategoryid: item['_indskr_contactchangerequest_value'] ?? null,
          indskr_changerequestcategoryname: item['crcategoryname'] ?? null,
        };
        if(item['indskr_searchentity.indskr_searchentityid']){
          let searchEntity = {
            indskr_searchentityid: item['indskr_searchentity.indskr_searchentityid'],
            indskr_attribute: item['indskr_searchentity.indskr_attribute'],
            indskr_relatedentity: item['indskr_searchentity.indskr_relatedentity']
          };
          formObj.search_entities.push(searchEntity);
        }
        if(item['indskr_linkedentityformconfigurations.indskr_linkedentityformconfigurationsid']){
          let linkedEntities = {
            indskr_entityname: item['indskr_linkedentityformconfigurations.indskr_entityname'],
            indskr_linkedentityformconfigurationsid: item['indskr_linkedentityformconfigurations.indskr_linkedentityformconfigurationsid'],
            indskr_maximumnumberofrecordsallowed: item['indskr_linkedentityformconfigurations.indskr_maximumnumberofrecordsallowed'],
            indskr_minimumnumberofrecordsallowed: item['indskr_linkedentityformconfigurations.indskr_minimumnumberofrecordsallowed'],
            indskr_requirementtype: item['indskr_linkedentityformconfigurations.indskr_requirementtype'],
            indskr_abilitytoremoverecords: item['indskr_linkedentityformconfigurations.indskr_abilitytoremoverecords'],
            linkedEntitiesFieldConfig: []
          };
          formObj.linked_entities_config.push(linkedEntities);
        }
        if(item['indskr_mobileappformfield.indskr_mobileappformfieldid']){
          let mandatoryFieldConfig = {
            indskr_mobileappformid: item['indskr_mobileappformfield.indskr_mobileappformid'],
            indskr_mobileappformfieldid: item['indskr_mobileappformfield.indskr_mobileappformfieldid'],
            indskr_mobileappformfieldname: item['indskr_mobileappformfield.indskr_mobileappformfieldname'],
            indskr_isrequired: item['indskr_mobileappformfield.indskr_isrequired'],
            indskr_filterby: item['indskr_mobileappformfield.indskr_filterby'],
            indskr_targetentityfilterfield: item['indskr_mobileappformfield.indskr_targetentityfilterfield'],
            indskr_target_entity_attribute: item['indskr_mobileappformfield.indskr_target_entity_attribute'],
            indskr_operatortype: item['indskr_mobileappformfield.indskr_operatortype'],
            indskr_viewtype: item['indskr_mobileappformfield.indskr_viewtype']
          };
          formObj.mandatory_field_config.push(mandatoryFieldConfig);
        }
        if(item['indskr_editconfig']){
          formObj.indskr_editconfig = item['indskr_editconfig'];
        }
        if (item['indskr_changerequesttype']) {
          formObj.indskr_changerequesttype = item['indskr_changerequesttype'];
        }
        result.push(formObj);
      }
    }
    return result;
  }

  private async saveFormsDefinitionToOfflineDB(rawForms, offlineDocs, isFullSync, timeDeltaSync) {
    let offlineForms;
    if(offlineDocs && offlineDocs["raw"]){
      offlineForms = offlineDocs["raw"];
    } else {
      offlineForms = [];
    }
    if(rawForms && Array.isArray(rawForms) && rawForms.length != 0) {

      if(!offlineForms || isFullSync) {
        offlineForms = rawForms;
      } else {

        let formToAdd = [];
        //Delta Sync
        for (let i = 0; i < rawForms.length; i++) {

          let form = rawForms[i];

          if(form.indskr_formtype == FormType.DISPLAYFORM) {
            if(form.indskr_entityname == "contact"){
            }
          } else {
          }

          if(Array.isArray(offlineForms)){
            //Remove recently modiefied forms from offlineForms and keep track of forms that has been published
            let idx = formToAdd.findIndex(a=> a.indskr_mobileappformid == form.indskr_mobileappformid);
            if(idx >= 0){
              if(form['statecode'] == 1 && form['statuscode'] == 2) {
                formToAdd[idx] = form;
              } else {
                formToAdd.splice(idx,1);
              }
            } else {
              if((form['statecode'] == 1 && form['statuscode'] == 2)) {
                formToAdd.push(form);
              }
            }
            let idy = offlineForms.findIndex(a=> a.indskr_mobileappformid == form.indskr_mobileappformid);
            if(idy >= 0)  {
              offlineForms.splice(idy,1);
            }
          }
        }

        // Get data of forms to add. This step is added to check wether the forms are assigned to users security role
        // forms that are not in users security role won't be returned from this fetchXML. :).
        if(formToAdd.length > 0) {
          let formIds = "";
          formToAdd.forEach(p => {
            formIds += '<value>' + p['indskr_mobileappformid'] + '</value>'
          })
          let idFilter = MOBILE_FORMS_ID_FILTER;
          idFilter = idFilter.replace('{FormIds}', formIds);

          let fetchXML = MOBILE_FORMS_FETCHXML;
          fetchXML = fetchXML.replace('{0}', this.authenticationService.user.systemUserID);
          fetchXML = fetchXML.replace('{BUID}', this.authenticationService.user.xBusinessUnitId);
          fetchXML = fetchXML.replace('{IdCondition}', idFilter);
          let response = await this.dynamics.executeFetchQuery('indskr_mobileappforms', fetchXML);
          if(response){
            if(response && Array.isArray(response) && response.length != 0) {
              let data = this.agreegateDynamicFormsResponse(response);
              //Fetch Business Rules
              await this.getBusineesRulesForMobileAppForms(data);
              if(data){
                offlineForms = [...offlineForms, ...data]
              }
            }
          }
        }
      }
      this.dynamicForms = offlineForms;
      this.disk.updateOrInsert(DB_KEY_PREFIXES.DYNAMIC_FORM, doc => {
        doc = {
          lastDeltaSync: timeDeltaSync.getTime(),
          raw: offlineForms,
        };
        return doc;
      })
      .catch(error => console.error('Save Forms to DB error: ', error));
    }
  }

  public getFormDefinitionForEntity(entity, formType:FormType, businessProcess?: BusinessProcessType, formChangeRequestType?: FormChangeRequestType, changeRequestCategoryId?: string):DynamicForm {
    try {
        let formDef;
        let foundForms = this.dynamicForms.filter(a=> a.indskr_entityname == entity && a.indskr_formtype == formType);
        if (businessProcess) {
          foundForms = foundForms.filter(a => a.indskr_businessprocess == businessProcess);
          if (formChangeRequestType) {
            foundForms = foundForms.filter(a => a.indskr_changerequesttype == formChangeRequestType);
          }
          if (changeRequestCategoryId) {
            foundForms = foundForms.filter(a => a.indskr_changerequestcategoryid == changeRequestCategoryId);
          } else if (entity == 'indskr_contactcr' || entity == 'indskr_accountcr') {
            foundForms = foundForms.filter(a => !a.indskr_changerequestcategoryid);
          }
        } else if (entity == 'contact' || entity == 'account') foundForms = foundForms.filter(a => a.indskr_businessprocess !== BusinessProcessType.OneKey);
        if (foundForms && Array.isArray(foundForms) && foundForms.length != 0){
          if(foundForms.length > 1){
            if (entity == 'indskr_contactcr' || entity == 'indskr_accountcr') {
              // formDef = null;
              if(businessProcess && businessProcess == BusinessProcessType.Omnipresence){
                this.notificationService.notify(this.translate.instant('MORE_THAN_ONE_FORM_CONFIGURED_ERR'), 'DynamicFormsService', "top", ToastStyle.DANGER, 3000);
              } else if (businessProcess == BusinessProcessType.SanofiChina) {
                const businessLine = this.authenticationService.user?.buConfigs?.indskr_businessline;
                if (businessLine === BusinessLineVal.PHARMA) {
                  foundForms = foundForms.filter(f => f.indskr_mdmusertype === MDM_USER_TYPE.PHARMA);
                } else if (businessLine === BusinessLineVal.VACCINE) {
                  foundForms = foundForms.filter(f => f.indskr_mdmusertype === MDM_USER_TYPE.VACCINE);
                } else if (businessLine === BusinessLineVal.RETAIL) {
                  foundForms = foundForms.filter(f => f.indskr_mdmusertype === MDM_USER_TYPE.RETAIL);
                } else if (businessLine === BusinessLineVal.VACCINE_MDM) {
                  foundForms = foundForms.filter(f => f.indskr_mdmusertype === MDM_USER_TYPE.VACCINE_MDM);
                }
              }
              if (foundForms.length > 1) return;
            } else {
              foundForms = foundForms.sort((a, b) => {
                return (this.dateTimeFormatsService.isBeforeDate(new Date(a['modifiedon']), new Date(b['modifiedon'])) ? 1 : -1);
              });
            }
          }
          formDef = foundForms[0];
        }

        if(!formDef){
          if(businessProcess && businessProcess == BusinessProcessType.Omnipresence){
            this.notificationService.notify(this.translate.instant('DONT_HAVE_FORM_CONFIGURED_ERR'), 'DynamicFormsService', "top", ToastStyle.DANGER, 3000);
          }
          return null;
        }
        let form = new DynamicForm(formDef);
        if(formDef.indskr_formtype == FormType.DISPLAYFORM) return form;

        for(let i = 0; i < form.metadata.length; i++) {
          const tab = form.metadata[i];
          if(tab && tab.controls && tab.controls.length > 0) {
            for(let j = 0; j < tab.controls.length; j++) {
              let control = tab.controls[j];
              if(!control.dataType) {
                if (control.subgrid) {
                  if (control.subgrid.targetEntityType) {
                    let foundForm = this.dynamicForms.find(a => a.indskr_entityname == control.subgrid.targetEntityType && a.indskr_formtype == FormType.CREATEFORM);
                    if (!foundForm && entity == 'indskr_contactcr' && changeRequestCategoryId != null && control.subgrid.targetEntityType == "exe_customerpositionchangerequests") {
                      control.forceHide = true;
                    }
                  }
                }
              }
            }
          }
        }
        return form;
    } catch (error) {
        console.error('Form Defination: ', error);
        return null;
    }
  }

  getFormFieldType(control:Control) {
    switch(control.dataType) {
        case ControlDataType.StringType:
        case ControlDataType.DecimalType:
        case ControlDataType.DoubleType:
        case ControlDataType.IntegerType:
        case ControlDataType.MoneyType:
        case ControlDataType.MemoType:
          return FormFieldType.INLINE_INPUT;
        case ControlDataType.LookupType:
          if((control.lookupEntityPrimaryId == 'accountid' && control.attributeName != 'indskr_surgeonaccountzsur') || control.lookupEntityPrimaryId == 'contactid' || control.lookupEntityPrimaryId == 'productid'){
            return FormFieldType.NEW_PAGE_SELECT;
          }
        case ControlDataType.MultiSelectPicklistType:
        case ControlDataType.PicklistType:
        case ControlDataType.BooleanType:
        case ControlDataType.DateTimeType:
          return FormFieldType.POPOVER_SELECT;
        default:
          return FormFieldType.INLINE_INPUT;
    }
  }

  public capturesTyping(control: Control): boolean {
    return capturesTyping(control.dataType);
  }

  public checkIfControlShouldNotBeVisible(control: Control): Boolean {
    let flag: boolean = false;
    if (control.dataType) {
      if (control.dataType == ControlDataType.StateType || control.dataType == ControlDataType.StatusType || control.dataType == ControlDataType.OwnerType || control.dataType == ControlDataType.CustomerType || control.dataType == ControlDataType.WebResource) {
        flag = true;
      }
      if (control.attributeName == 'indskr_submittedon' || control.attributeName == 'createdby' || control.attributeName == 'createdon' || control.attributeName == 'modifiedby' || control.attributeName == 'modifiedon') {
        flag = true;
      }
    }
    // if(control.isVisible){
    //   flag = true;
    // }
    return flag;
  }

  public checkIfControlShouldNotBeVisibleInDisplayForm(control: Control): Boolean {
    let flag: boolean = false;
    if (control.dataType) {
      if (control.dataType == ControlDataType.StateType || control.dataType == ControlDataType.StatusType || control.dataType == ControlDataType.CustomerType || control.dataType == ControlDataType.WebResource) {
        flag = true;
      }
      if (control.attributeName == 'indskr_submittedon' || control.attributeName == 'createdby' || control.attributeName == 'createdon' || control.attributeName == 'modifiedby' || control.attributeName == 'modifiedon') {
        flag = true;
      }
    }
    // if(control.isVisible){
    //   flag = true;
    // }
    return flag;
  }

  getControl(form: DynamicForm, id) {
    let control;
    for(let md of form.metadata) {
      control = md.controls.find(x => x.attributeName == id);
      if(control) return control;
    }
    return control;
  }

  async getLookupResults(searchParams, control: Control, filterXml, isOneKey?: boolean): Promise<any> {

    let lookupQueries = control.lookupQueries;
    let maximumCount = "1000";
    if(searchParams && searchParams.length > 3 && control && control.attributeName == "indskr_city_lu") {
      maximumCount = "5000";
    }
    const isOneKeyCodeLabels: boolean = control.lookupEntitySetName == "omnione_onekeycodeslabelses" && this.authenticationService.user.securityRoles.some(a=> a.name == 'iO OneKey User' || a.name == 'iO OneKey Admin');

    let fetchXML = lookupQueries.fetchXml
    fetchXML = fetchXML.replace(`{addressfieldsfilter}`, filterXml);
    fetchXML = fetchXML.replace(`count="{0}"`, `count="`+maximumCount+`"`);
    fetchXML = fetchXML.replace("{PositionFilter}", this._getPositionFilter());

    /***Jumbled search - set fetchXML, searchText***/
    let formattedSearchText = searchParams ? this.convertFormattedString(searchParams) : '';
    const cntWordsInSearchText = formattedSearchText.split(" ").filter(sw => {return sw !=''}).length;
    let lookupEntityPrimaryName = control.lookupEntityPrimaryName;
    const targetFilterFetchXML = `<condition attribute="${lookupEntityPrimaryName}" operator="like" value="{0}" />`
    let searchTextSplitWords: string[] = [];
    if(formattedSearchText && formattedSearchText.trim() !='') {
      // if(isOneKeyCodeLabels && this.islookupSearchMultilingualData) lookupEntityPrimaryName = multilingualLanguageToAttributeMapping["dynamics_language_code_"+this.authenticationService.user.localeId];
      if(isOneKeyCodeLabels && this.islookupSearchMultilingualData) lookupEntityPrimaryName = this.localizationService.getOneKeyTableAttributes();
      const jumbledSearchFetchXMLandWords = this._getJumbledSearchFetchXMLandWords(formattedSearchText, lookupEntityPrimaryName);
      const jumbledSearchFilterFetchXML = jumbledSearchFetchXMLandWords.searchFilterFetchXML;
      searchTextSplitWords = jumbledSearchFetchXMLandWords.searchWords;

      // Scenario where fetchXML has no filter/search conditions from the configured form
      if (!fetchXML.includes(targetFilterFetchXML)) {
        // Find the index of the filter tag to insert search condition inside the filter
        const filterOpenTagIndex = fetchXML.indexOf('<filter type="or"');
        if (filterOpenTagIndex > -1) {
          const filterCloseTagIndex = fetchXML.indexOf('>', filterOpenTagIndex);
          if (filterCloseTagIndex > -1) {
            fetchXML = fetchXML.slice(0, filterCloseTagIndex + 1) + targetFilterFetchXML + fetchXML.slice(filterCloseTagIndex + 1);
          }
        } else {
          // Find the index of the entity tag to add filter and search condition
          const entityOpenTagIndex = fetchXML.indexOf('<entity');
          if (entityOpenTagIndex > -1) {
            const entityCloseTagIndex = fetchXML.indexOf('>', entityOpenTagIndex);
            if (entityCloseTagIndex > -1) {
              const filterCondition: string = `<filter type="or">${targetFilterFetchXML}</filter>`;
              fetchXML = fetchXML.slice(0, entityCloseTagIndex + 1) + filterCondition + fetchXML.slice(entityCloseTagIndex + 1);
            }
          }
        }
      }

      fetchXML = fetchXML.replace(targetFilterFetchXML, jumbledSearchFilterFetchXML);
    } else{
      const re = new RegExp(`\\{0\\}`, 'g');
      fetchXML = fetchXML.replace(re, `%`);
    }
    //onekeycodelabes - set fetchXML
    if(isOneKeyCodeLabels) {
      let key = this.localizationService.getOneKeyTableAttributes();
      const multilingualFetchXML = `
        <attribute name="omnione_onekeycodeslabelsid" />
        <attribute name="${key}" alias="multilingual_value"/>
        <attribute name="omnione_cod_id_onekey" />
        <attribute name="statecode" />
        <filter type="and">
          <condition attribute="omnione_schemafieldname" operator="eq" value="${control.attributeName}" />
          <condition attribute="statecode" operator="eq" value="0" />
        </filter>
      `;
      // <condition attribute="omnione_bu" operator="eq" value="${this.authenticationService.user.businessUnitName}" />
      fetchXML = fetchXML.replace(`<attribute name="omnione_onekeycodeslabelsid" />`,multilingualFetchXML);
    }
    let sr: LookupSearchResult[] = [];
    this.lookupSearchData = [];
    //related to address - postal code, district, city search
    if(control.lookupEntityPrimaryId == "indskr_lu_postalcodeid") {
      //DSE-UAT, the generated fetch xml from Dynamics has following filters and causes the error.
      //Temporary solution is implemented to remove these filters
      fetchXML = fetchXML.replace(`<condition attribute="indskr_city" operator="like" value="%" />`, '');
      fetchXML = fetchXML.replace(`<condition attribute="omnione_cityname" operator="like" value="%" />`, '');
      const postalCodeBasedOnCityFetchXML = `
        <attribute name="indskr_lu_postalcodeid" />
        <filter type="and">
          <condition attribute='statecode' operator='eq' value='0'/>
          <condition attribute="indskr_city" operator="eq" value="{filteredByCityId}" />
        </filter>
        `;
      if (!isEmpty(filterXml)) {
        fetchXML = fetchXML.replace(`<attribute name="indskr_lu_postalcodeid" />`, postalCodeBasedOnCityFetchXML);
        fetchXML = fetchXML.replace(`{filteredByCityId}`, filterXml);
      }
    } else if(control.lookupEntityPrimaryId == "indskr_lu_districtid") {
      const countyDistrictBasedOnStateIdFetchXML = `
        <attribute name="indskr_lu_districtid" />
        <attribute name="indskr_countycode" />
        <filter type="and">
          <condition attribute='statecode' operator='eq' value='0'/>
          <condition attribute="indskr_stateprovince" operator="eq" value="{filteredByStateId}" />
        </filter>
       `;
       if (!isEmpty(filterXml)) {
        fetchXML = fetchXML.replace(`<attribute name="indskr_lu_districtid" />`, countyDistrictBasedOnStateIdFetchXML);
        fetchXML = fetchXML.replace(`{filteredByStateId}`, filterXml);
       }
    } else if(control.lookupEntityPrimaryId == 'indskr_lu_cityid' && this.hasCityDataBasedOnCountry) {
      if(formattedSearchText && formattedSearchText.trim() !='') {
        this.lookupSearchData = this.lookupSearchDataForCityBasedOnCountry.filter(x=> {
          formattedSearchText = formattedSearchText.toLowerCase();
          const formattedNameForSearch = this.convertFormattedString(x.nameForSearch).toLowerCase();
          const formattedName = this.convertFormattedString(x.name).toLowerCase();
          return formattedNameForSearch.includes(formattedSearchText) || formattedName.includes(formattedSearchText);
        });
      } else this.lookupSearchData = this.lookupSearchDataForCityBasedOnCountry;
      return;
    }
    // if(control.attributeName == 'indskr_shipto' && filter) {
    //   const entityOpenTagIndex = fetchXML.indexOf('<entity');
    //       if (entityOpenTagIndex > -1) {
    //         const entityCloseTagIndex = fetchXML.indexOf('>', entityOpenTagIndex);
    //         if (entityCloseTagIndex > -1) {
    //           fetchXML = fetchXML.slice(0, entityCloseTagIndex + 1) + filter + fetchXML.slice(entityCloseTagIndex + 1);
    //         }
    //       }
    // }
    if (control.dataType== ControlDataType.LookupType && filterXml && control.filterby && (control.filterFieldTargetLookupEntity || control.targetEntityAttribute)) {
      const entityOpenTagIndex = fetchXML.indexOf('<entity');
        if (entityOpenTagIndex > -1) {
          const entityCloseTagIndex = fetchXML.indexOf('>', entityOpenTagIndex);
          if (entityCloseTagIndex > -1) {
            fetchXML = fetchXML.slice(0, entityCloseTagIndex + 1) + filterXml + fetchXML.slice(entityCloseTagIndex + 1);
          }
        }
    }
    //execute fetch query
    this.lookupSearchInProgress = true;
    let pageCount = 0;
    await this.dynamics.executeFetchQueryWithPageNumber(control.lookupEntitySetName, fetchXML,pageCount)
          .then((res) => {
            this.islookupSearchMultilingualData = false;
            this.islookupSearchMultilingualData = res.some(r=>r['multilingual_value']);
            for(let r of res) {
              let data;
              if(control.attributeName.startsWith('exe_') && control.lookupQueries?.entityName == "indskr_address") {
                data = r;
                data['name'] = r['indskr_composite'] || '';
                data['nameForSearch'] = r['indskr_composite']?.toLowerCase() || '';
              } else if(isOneKeyCodeLabels && r["multilingual_value"]) data = new LookupSearchResult(r, control.lookupEntityPrimaryId, "multilingual_value");
              else data = new LookupSearchResult(r, control.lookupEntityPrimaryId, control.lookupEntityPrimaryName);
              if (r['_indskr_product_value']) data.productId = r['_indskr_product_value'];
              // Generic counterpart to productId above: productId only ever reads the
              // indskr_product/_indskr_product_value convention, so a cascading filter configured
              // with a different filterFieldTargetLookupEntity (e.g. a different customer's own
              // custom field) would never populate it. filterFieldValue reads whatever this
              // control's own config actually names, so callers doing a client-side match against
              // a configured cascading filter (e.g. offline auto-select) aren't tied to that one
              // hardcoded convention.
              if (control.filterFieldTargetLookupEntity) {
                data.filterFieldValue =
                  r[control.filterFieldTargetLookupEntity] ?? r[`_${control.filterFieldTargetLookupEntity}_value`] ?? undefined;
              }
              if(r['multilingual_value']){
                data.name = data.nameForSearch = r['multilingual_value'];
              }
              //sorting results with weighted values
              if(formattedSearchText && formattedSearchText.trim() !='') {
                let weightedMatchChar: number = 0;
                searchTextSplitWords.forEach((sw, idx) => {
                  const searchWordLength = sw.length;
                  sw = sw.toLowerCase();
                  let nameForSearch = this.convertFormattedString(data.nameForSearch).toLowerCase();
                /** Weighted values(wv) for the matched letters
                 * 1. Input text by a user (determined by cntWordsInSearchText)
                 *  a. checking exact matched words or included search parameters: wv is searchWordLength + 20 or 10,
                 *  b. matched split word is more than 3 letters: wv is searchWordLength + 3,
                 *  c. matched split word is less than 3 letters: wv is searchWordLength
                 * 2. Jumbled text
                 *  a. matched split word is 3 letters : wv is 1
                 * 3. No matched split word: wv is 0
                */
                  if(idx == 0 && searchWordLength > 3 && nameForSearch && nameForSearch.includes(sw)) {
                    weightedMatchChar += nameForSearch.length == searchWordLength ? searchWordLength + 20 : searchWordLength + 10;
                  }else {
                    weightedMatchChar += nameForSearch.split(sw).length  > 1 ? idx < cntWordsInSearchText ? searchWordLength > 3 ? searchWordLength + 3 : searchWordLength : 1 : 0;
                  }
                });
                data.totalWeightedMatch = weightedMatchChar;
              }
              sr.push(data);
            }
            sr.sort((a, b) => (b.totalWeightedMatch - a.totalWeightedMatch || a.nameForSearch.localeCompare(b.nameForSearch)));

            if(formattedSearchText && formattedSearchText.trim() !='') {
              sr = filter(sr, function (result:LookupSearchResult) {
                return result.totalWeightedMatch > 0;
              });
            }

            this.lookupSearchData = sr;
            if (control.otherOptionField) {
              this.appendOtherLookupOption();
            }
            this.lookupSearchInProgress = false;
            return sr;
          },
          (err) => {
            console.log('Lookup search dynamics error', err);
            this.lookupSearchInProgress = false;
          })
    return sr;
  }

  // Appends a synthetic 'Other' entry as the last item of the current lookup
  // results, for controls that declare an otherOptionField. Idempotent so repeated
  // searches don't stack duplicates. Selection is handled by the form component,
  // which reveals the control's configured free-text field.
  appendOtherLookupOption(): void {
    if (!this.lookupSearchData) {
      this.lookupSearchData = [];
    }
    if (this.lookupSearchData.some(r => r && r.id === OTHER_LOOKUP_OPTION_ID)) {
      return;
    }
    const otherOption = new LookupSearchResult({}, '', '');
    otherOption.id = OTHER_LOOKUP_OPTION_ID;
    otherOption.name = this.translate.instant('OTHER');
    otherOption.nameForSearch = otherOption.name.toLowerCase();
    otherOption.isOtherOption = true;
    this.lookupSearchData.push(otherOption);
  }

  async getLookupResultsForCityBasedOnCountry(searchByCountryId, control: Control): Promise<any> {
    let fetchXML;
    fetchXML = `<fetch version="1.0" output-format="xml-platform" mapping="logical" distinct="true">
      <entity name="indskr_lu_country">
        <attribute name="indskr_countryname" />
        <attribute name="createdon" />
        <attribute name="statecode" />
        <filter type="and">
          <condition attribute="statecode" operator="eq" value="0" />
        </filter>
        <filter type="or">
          <condition attribute="indskr_lu_countryid" operator="eq" value="{0}" />
        </filter>
        <attribute name="indskr_lu_countryid" />
        <link-entity name="indskr_lu_state" from="indskr_lu_countryid" to="indskr_lu_countryid" link-type="outer" alias="bt">
          <link-entity name="indskr_lu_city" from="indskr_state" to="indskr_lu_stateid" link-type="outer" alias="bu">
            <attribute name="indskr_lu_cityid" />
            <attribute name="indskr_name" />
            <attribute name="indskr_state" />
            <attribute name="indskr_statename" />
            <attribute name="statecode" />
            <order attribute="indskr_name" descending="false" />
          </link-entity>
        </link-entity>
      </entity>
    </fetch>`;
    let re = new RegExp(`\\{0\\}`, 'g');
    fetchXML = fetchXML.replace(re, searchByCountryId);

    let sr: LookupSearchResult[] = [];
    this.lookupSearchDataForCityBasedOnCountry = [];
    this.hasCityDataBasedOnCountry = false;
    const loader = await this.loadingController.create({});
    loader.present();

    let index = 1;
    let hasMoreRecords = false;
    let values = []
    do {  
      try {
        let response = await this.dynamics.executeFetchXml(control.lookupEntitySetName, fetchXML,'*',index)

        hasMoreRecords = false;
  
        if ( response.value && isArray(response.value) && !isEmpty(response.value)) {
          values = values.concat(response.value)
        }
  
        if (response.hasOwnProperty(DynamicsConstant.hasMoreRecords)) {
          hasMoreRecords = response[DynamicsConstant.hasMoreRecords]
        }
        index = index + 1;
      } catch(error) {
        console.log("Error retreiving getLookupResultsForCityBasedOnCountry: ", error);
        hasMoreRecords = false;
      }
    } while (hasMoreRecords)
    //Do not add any filters in the above linked entity indskr_lu_city. This is the outer join type. Adding fitler causes performance issues.
    values = values.filter(v=>v.statecode == 0);
    values.forEach(r => {
      let hasCityDataToStore: boolean = this.checkCityData(r, 'indskr_lu_cityid');
      if(hasCityDataToStore) {
        sr.push(new LookupSearchResult(r, control.lookupEntityPrimaryId, control.lookupEntityPrimaryName));
      }

      if (sr) {
        sr.forEach(x=> {
          x.id = x.cityId;
          x.name = x.cityName;
          x.nameForSearch = x.cityName.toLowerCase();
        })
        /**city entity does not have a relationship with the country entity. So, the city cannot be filtered by country in fetchXML.
         * When a country is selected, city data is stored through the state entity in fetchXML
         */
        this.lookupSearchDataForCityBasedOnCountry = sr;
        if (this.lookupSearchDataForCityBasedOnCountry) {
          this.hasCityDataBasedOnCountry = true;
        }
      }
    });
    loader.dismiss();

    if (this.lookupSearchDataForCityBasedOnCountry) {
      this.hasCityDataBasedOnCountry = true;
    }
  }

  async getLookupCodIdOnekey(schemaFieldName: string, onekeyCodesLabelsId: string): Promise<string> {
    let codIdOnekey: string = '';
    if(!schemaFieldName || !onekeyCodesLabelsId) return codIdOnekey;
    let fetchXML;
    fetchXML = `<fetch returntotalrecordcount='true' version="1.0" mapping="logical">
    <entity name='omnione_onekeycodeslabels'>
      <attribute name='omnione_onekeycodeslabelsid'/>
      <attribute name='omnione_name'/>
      <attribute name='omnione_cod_id_onekey'/>
      <order attribute='omnione_name' descending='false'/>
      <filter type='and'>
        <condition attribute='omnione_schemafieldname' operator='eq' value='{0}' />
        <condition attribute='omnione_onekeycodeslabelsid' operator='eq' value='{0}' />
      </filter>
    </entity>
    </fetch>`;

    const targetFilterSchemaField = `<condition attribute='omnione_schemafieldname' operator='eq' value='{0}' />`;
    const targetFilterOnekeyCodesLabelsId = `<condition attribute='omnione_onekeycodeslabelsid' operator='eq' value='{0}' />`;
    const re = new RegExp(`\\{0\\}`, 'g');
    const setFilterSchemaField = targetFilterSchemaField.replace(re, schemaFieldName);
    fetchXML = fetchXML.replace(targetFilterSchemaField, setFilterSchemaField);
    const SetFilterOnekeyCodesLabelsId = targetFilterOnekeyCodesLabelsId.replace(re, onekeyCodesLabelsId);
    fetchXML = fetchXML.replace(targetFilterOnekeyCodesLabelsId, SetFilterOnekeyCodesLabelsId);

    await this.dynamics.executeFetchQueryWithPageNumber('omnione_onekeycodeslabelses', fetchXML, 0)
          .then((res) => {
            if(res[0] && res[0].omnione_cod_id_onekey) codIdOnekey = res[0].omnione_cod_id_onekey;
          },
          (err) => {console.log('Lookup search dynamics error', err);});
    return codIdOnekey;
  }

  async getLookupCountyCodeOneKey(lookupEntitySetName: string, lookupId: string): Promise<string> {
    let countyCodeOneKey: string = '';
    let fetchXML;
    fetchXML = `<fetch returntotalrecordcount='true' version="1.0" mapping="logical">
    <entity name='indskr_lu_district'>
      <attribute name='indskr_name'/>
      <attribute name='indskr_lu_districtid'/>
      <attribute name='indskr_countycode'/>
      <order attribute='indskr_name' descending='false'/>
      <filter type='and'>
        <condition attribute='statecode' operator='eq' value='0'/>
        <condition attribute='indskr_lu_districtid' operator='eq' value='{0}' />
      </filter>
    </entity>
    </fetch>`;

    const re = new RegExp(`\\{0\\}`, 'g');
    fetchXML = fetchXML.replace(re, lookupId);

    await this.dynamics.executeFetchQueryWithPageNumber(lookupEntitySetName, fetchXML, 0)
          .then((res) => {
            if(res[0] && res[0].indskr_countycode) countyCodeOneKey = res[0].indskr_countycode;
          },
          (err) => {console.log('Lookup search dynamics error', err);});
    return countyCodeOneKey;
  }

  async getLookupStateIdBasedOnCity(lookupEntitySetName: string, lookupId: string): Promise<string> {
    let stateId: string = '';
    let fetchXML;
    fetchXML = `<fetch returntotalrecordcount='true' version="1.0" mapping="logical">
    <entity name='indskr_lu_city'>
      <attribute name='indskr_name'/>
      <attribute name='indskr_state'/>
      <attribute name='indskr_lu_cityid'/>
      <order attribute='indskr_name' descending='false'/>
      <filter type='and'>
        <condition attribute='statecode' operator='eq' value='0'/>
        <condition attribute='indskr_lu_cityid' operator='eq' value='{0}' />
      </filter>
    </entity>
    </fetch>`;

    const re = new RegExp(`\\{0\\}`, 'g');
    fetchXML = fetchXML.replace(re, lookupId);

    await this.dynamics.executeFetchQueryWithPageNumber(lookupEntitySetName, fetchXML, 0)
          .then((res) => {
            if(res[0] && res[0]._indskr_state_value) stateId = res[0]._indskr_state_value;
          },
          (err) => {console.log('Lookup search dynamics error', err);});
    return stateId;
  }

  private _getPositionFilter() {
    let positionIds = this.authenticationService.user.positions.map(o => {
      return o.ID
    });

    if(!positionIds) return "";
    let positionString = '';
    positionIds.forEach(p => {
      positionString += '<value>' + p + '</value>'
    })

    return positionString;
  }

  public getDropdownListViewFromOptionSet(options:Array<Option>,selectedValue,langCode:string):IndDropdownListDetailModel{
    const selected = selectedOptionValues(selectedValue);
    let dropdownListDetail:IndDropdownListDetailModel = {
      id: 'dynamicform-picklist-select',
      data: options.map((option,optionIndex) => {
        let data:SelectListData;
        try {
          if(option && isOptionValueSet(option.value) && option.displayNames && option.displayNames.length != 0){
            let foundDisplayName = option.displayNames.find(a=> a.languagecode == langCode) || option.displayNames.find(a=> a.languagecode == '1033');
            if(foundDisplayName){
              data = {
                title: foundDisplayName.description,
                id: option.value.toString(),
                isSelected: selected.has(String(option.value)),
              }
            }
          }
        } catch (error) {
          console.log('Error occured while parsing option set data'+error);
        }
        return data;
      }).filter(option => option),
    };
    return dropdownListDetail;
  }
  /**
   * With debounce
   */
  async getLookupSearchResults(searchParams, lookupQueries: LookupQuery) {
    this.searchResultsObs$ = this.searchParamsSub.pipe(
      debounceTime(1000),
      map(searchParams => {

        let fetchXML = lookupQueries.fetchXml.replace(`{0}`, searchParams + `%`);
        let sr: LookupSearchResult[] = [];
        this.dynamics.executeFetchQuery(lookupQueries.entityName + "s", fetchXML)
          .then((res) => {
            for(let r of res) {
              //sr.push(new LookupSearchResult(r));
            }
            return sr;
          },
          (err) => {
            console.log('Lookup search dynamics error', err);
          })
      })
    )

  }

  public async getOptionSet(attrName) {

    let options: Option[] = [];

    let result = await this.dynamics.retrieveGlobalOptionSet("Name='" + attrName + "'");
    if(result && result['Options'] && Array.isArray(result['Options']) ) {
      let rawOptions = result['Options'];
      rawOptions.forEach(op => {
        options.push(new Option(op));
      });
    }
    return options;

  }

  public async createLinkedEntity(payload, entityName) {

    let headers = Endpoints.headers.content_type.json;
      headers.headers = headers.headers.set(
          'No-Retry', 'true'
      );
    let url = this.authenticationService.userConfig.activeInstance.entryPointUrl
        + Endpoints.dynamic_forms.CREATE_LINKED_ENTITY.replace('{entityName}', entityName);
    try {
      const response = await this.http.post(url, payload, headers).toPromise();
      if (response) {
        return response;
      }
    } catch (httpError) {
        console.log(httpError);
        if (httpError.error.errorCode == 'ERR_IO_500' && httpError.error.errorMessage.includes("duplicate")) {
          this.notificationService.notify(this.translate.instant('DUPLICATE_DETECTED'), 'DynamicFormComponent', 'top', ToastStyle.DANGER, 3000);
        } else {
          this.notificationService.notify( this.translate.instant('FAILED_CREATING_LINKED_ENTITY_GENERIC_ERROR_MESSAGE'), 'DynamicFormComponent', 'top', ToastStyle.DANGER, 3000);
        }
    }

  }

  public getSearchConfigDisplayText(dtArray: DisplayText[],formType:DynamicFormType, isCustomControl: boolean = false, attributeName?: string, entityName?: string) {
    if(!dtArray) return "";

    let displayText: string;
    if (entityName && (entityName == 'contact' || entityName == 'account') && attributeName && attributeName == 'statuscode') {
      return displayText = this.translate.instant('VERIFICATION');
    }
    let langCode = (formType == DynamicFormType.DEFAULTFORM || isCustomControl) ? "0000" : this.localizationService.selectedLanguage.localeID;
    let dt = dtArray.find(value => value.languagecode == langCode);

    if(dt) {
        displayText = dt.languagecode == "0000" ?  this.translate.instant(dt.description) : dt.description;
    } else {
        let en = dtArray.find(value => value.languagecode == "1033"); // default to english if no translation for the specific language;
        if(en) {
            //check multilingualLabels
            displayText = this.localizationService.getTranslatedString(en.description, EntityNameForTranslation.MobileAppForm);
        } else {
            displayText = "";
        }
    }
    return displayText;
  }

  public mapAddressOneKey(searchedData) {
    let searchedDataMap = []
    searchedData.forEach(sData => {
        let acaObj = {
          createdon: sData['createdon_Formatted'] ? sData['createdon_Formatted'] : '',
          indskr_addressid: sData['indskr_addressid'] ? sData['indskr_addressid'] : '',
          indskr_accountid: sData['ap.accountid'] ? sData['ap.accountid'] : '',
          indskr_composite: sData['indskr_composite'] ? sData['indskr_composite'] : '',
          indskr_compositecitystate: sData['indskr_compositecitystate'] ? sData['indskr_compositecitystate'] : '',
          indskr_name: sData.indskr_name ? sData.indskr_name: '',
          indskr_shipto: sData['ao.indskr_shipto_Formatted'] ? sData['ao.indskr_shipto_Formatted'] : '',
          indskr_country_lu_value: sData['_indskr_country_lu_value'] ? sData['_indskr_country_lu_value'] : '',
          indskr_country_lu_value_Formatted: sData['_indskr_country_lu_value_Formatted'] ? sData['_indskr_country_lu_value_Formatted'] : '',
          indskr_state_lu_value: sData['_indskr_state_lu_value'] ? sData['_indskr_state_lu_value'] : '',
          indskr_state_lu_value_Formatted: sData['_indskr_state_lu_value_Formatted'] ? sData['_indskr_state_lu_value_Formatted'] : '',
          indskr_city_lu_value: sData['_indskr_city_lu_value'] ? sData['_indskr_city_lu_value'] : '',
          indskr_city_lu_value_Formatted: sData['_indskr_city_lu_value_Formatted'] ? sData['_indskr_city_lu_value_Formatted'] : '',
          indskr_postalcode_lu_value: sData['_indskr_postalcode_lu_value'] ? sData['_indskr_postalcode_lu_value'] : '',
          indskr_postalcode_lu_value_Formatted: sData['_indskr_postalcode_lu_value_Formatted'] ? sData['_indskr_postalcode_lu_value_Formatted'] : '',
          indskr_line3: sData['indskr_line3'] ? sData['indskr_line3'] : '',
          indskr_line2: sData['indskr_line2'] ? sData['indskr_line2'] : '',
          indskr_line1: sData['indskr_line1'] ? sData['indskr_line1'] : '',
          indskr_postofficebox: sData['indskr_postofficebox'] ? sData['indskr_postofficebox'] : '',
          indskr_district_value: sData['_indskr_district_value'] ? sData['_indskr_district_value'] : '',
          indskr_district_value_Formatted: sData['_indskr_district_value_Formatted'] ? sData['_indskr_district_value_Formatted'] : '',
        }
        if(acaObj.indskr_addressid) {
          searchedDataMap.push(acaObj);
        }
    });
    return searchedDataMap;
  }

   appendSortCriteria(JSONQuery: any, linkEntityAttributesStr: string) {
    if (JSONQuery.fetch.entity[0]['order'] && JSONQuery.fetch.entity[0]['order'].length) {
      JSONQuery.fetch.entity[0]['order'].forEach(sort => {
        linkEntityAttributesStr += `<order attribute="${sort.$.attribute}" descending="${sort.$.descending}"/>`;
      });
    }
    return linkEntityAttributesStr;
  }

  appendFilterCriteria(JSONQuery: any, linkEntityAttributesStr: string, forLinkedEntity = false) {
    if (!forLinkedEntity) {
      if (JSONQuery.fetch.entity[0]['filter'] && JSONQuery.fetch.entity[0]['filter'].length) {
        JSONQuery.fetch.entity[0]['filter'].forEach(filter => {
          linkEntityAttributesStr += this.buildFilterConditionString(filter);
        });
      }
    } else {
      if (JSONQuery.filter && !isEmpty(JSONQuery.filter)) {
        JSONQuery.filter.forEach(filter => {
          linkEntityAttributesStr += this.buildFilterConditionString(filter);
        });
      }
    }
    return linkEntityAttributesStr;
  }

  private getFilterToken(filterString: string, filter: any) {
    filterString += '<filter';

    // If type is for filter is not available close with cosing tag ">".
    if (filter.$ && filter.$.type) {
      filterString += ` type="${filter.$.type}">`;
    } else {
      filterString += '>';
    }
    return filterString;
  }

  private buildFilterConditionString(filter: any): string {
    let filterString = '';
    filterString = this.getFilterToken(filterString, filter);

    if (filter.condition && filter.condition.length) {
      filter.condition.forEach(con => {
        const attributeName = con.$.attribute;
        const operatorName = con.$.operator;
        // Ignoring the only condition accepting either contact ID or account ID or any value which has to be put instead of {0}
        // As this is taken care above for in the entity level filter criteria.
        if (con.$.value) {
          filterString += con.$.value === '{0}' ? '' : `<condition attribute="${attributeName}" operator="${operatorName}" value="${con.$.value}"/>`;
        } else if (con.value && con.value.length > 0) {
          filterString += `<condition attribute="${attributeName}" operator="${operatorName}">`;
          let valueString = '';
          con.value.forEach(val => {
            let formattedValue: string = '';
            if (val && val._ && typeof val._ === 'string') {
              formattedValue = val._;
            } else if (val && typeof val === 'string') {
              formattedValue = val;
            }
            if (!isEmpty(formattedValue)) {
              valueString += `<value>${formattedValue}</value>`;
            }
          });
          if (valueString) filterString += valueString;
          filterString += '</condition>';
        } else {
          filterString += `<condition attribute="${attributeName}" operator="${operatorName}" />`;
        }
      });
      filterString += '</filter>';
    } else {
      filterString = '<filter></filter>';
    }
    // remove empty filter condition
    filterString = filterString.replace('<filter></filter>', '');
    return filterString;
  }

  private checkCityData(raw: any, target: string) {
    let rawData = [];
    let foundValue;
    for (let r in raw) {
      rawData.push({
        key: r,
        value: raw[r]
      });
    }
    rawData.forEach(x=> {
        let mKey = x.key.replace(/\w+.\./g,'');
        if (mKey == target) {
          foundValue = x.value;
        }
      });
    return foundValue ? true : false;
  }


  /**
   * Display form
   ******************************************************************************************************************
   */

  getDefaultAffiliationsFilters(): AffiliationsFilters {
    let affiliationsFilters = {};
    const text = this.translate.instant('ALL');
    affiliationsFilters[ACCOUNT_ACCOUNT_AFFILIATIONS_VIEW_ID] = {
      filteredRecordCount: -1,
      filters: [
        {
          filterBy: 'fromToRelation',
          value: 'all',
          text,
        },
        {
          filterBy: 'sourceType',
          value: 'all',
          text,
        }
      ]
    };
    affiliationsFilters[CONTACT_CONTACT_AFFILIATIONS_VIEW_ID] = {
      filteredRecordCount: -1,
      filters: [
        {
          filterBy: 'fromToRelation',
          value: 'all',
          text,
        },
        {
          filterBy: 'sourceType',
          value: 'all',
          text,
        }
      ]
    };
    affiliationsFilters[ACCOUNT_CONTACT_AFFILIATIONS_VIEW_ID] = {
      filteredRecordCount: -1,
      filters: [
        {
          filterBy: 'sourceType',
          value: 'all',
          text,
        }
      ]
    };
    affiliationsFilters[CONTACT_ACCOUNT_AFFILIATIONS_VIEW_ID] = {
      filteredRecordCount: -1,
      filters: [
        {
          filterBy: 'sourceType',
          value: 'all',
          text,
        }
      ]
    };

    return affiliationsFilters;
  }
  updateAffiliationsFilter(affiliationsFilters: AffiliationsFilters, viewId: string, filterBy: string, value: string, text: string) {
    if (affiliationsFilters && affiliationsFilters[viewId] && Array.isArray(affiliationsFilters[viewId].filters)) {
      let filters = affiliationsFilters[viewId].filters;
      let filter = filters.find(f => f.filterBy === filterBy);
      if (filter) {
        filter.value = value;
        filter.text = text;
      } else {
        filter = {
          filterBy,
          value,
          text,
        };
        filters.push(filter);
      }
    }
  }
filterAffiliations(linkedEntityValues: any, affiliationsFilters: AffiliationsFilters, viewId: string) {
    let filteredRecordCount = 0;
    if (linkedEntityValues
        && Array.isArray(linkedEntityValues[viewId])
        && affiliationsFilters
        && affiliationsFilters[viewId]
        && Array.isArray(affiliationsFilters[viewId].filters)) {

      const filters = affiliationsFilters[viewId].filters;

      for (let i = 0; i < linkedEntityValues[viewId].length; i++) {
        const cardData = linkedEntityValues[viewId][i];

        let isFiltered = false;
        for (let j = 0; j < filters.length; j++) {
          const filter = filters[j];
          if (filter.value !== 'all' && filter.value !== 'target') {
            isFiltered = ((cardData.filter
              && (!cardData.filter[filter.filterBy]
                || (cardData.filter[filter.filterBy]
                  && cardData.filter[filter.filterBy] !== filter.value)
                )
              )
            || !cardData.filter);
          } else if (filter.value === 'target') {
            let contactsMatchedAlready = intersectionBy(this.affiliatedContacts, this.targetContactIds, 'ID');

            let selIndex = contactsMatchedAlready.findIndex((actId) => actId.fullname === cardData.primaryText); //Check for duplicates
            if (selIndex === -1) {
              isFiltered = true;
            }
          }

          if (isFiltered) {
            break;
          }
        }
        cardData.isFiltered = isFiltered;
        if (!isFiltered) {
          filteredRecordCount++;
        }
      }

      affiliationsFilters[viewId].filteredRecordCount = filteredRecordCount;
    }
  }
  //Multilingual support - translate option set value
  public translatedValue(value): string {
    let _value: string;
    const formattedValue: string = value.replace(/ |\//g,"_").toUpperCase(); //set key value for translation
    // Option set value for Status and Status Reason
    // Status: Active, Inactive
    // Status Reason: Provisional, Valid, Invalid, Closed, Deceased, Maternity/Paternity leave, Open, Is Opening, Retired, Temporarily Closed, Temporarily Inactive.
    _value = this.translate.instant(formattedValue);
    if (_value != formattedValue) {
      return _value;
    } else return value; //not found translation key
  }
  // Resolve affiliation label: configured subgrid column name, else the translation key.
  // Display names are keyed by Dynamics LCID ('1033'), so they must be resolved through
  // getSearchConfigDisplayText - it picks the active locale, falls back to English and
  // applies multilingual label overrides. Matching on translate.currentLang ('en') never
  // hit, so every configured label was silently discarded.
  private resolveAffiliationLabel(
    displayNames: any[],
    formType: any,
    fallbackKey: string,
    hardcodedDefault: string | null = null
  ): string {
    const label = this.getSearchConfigDisplayText(displayNames, formType);
    const useDefault = isEmpty(label) || formType === DynamicFormType.DEFAULTFORM || (hardcodedDefault !== null && label === hardcodedDefault);
    return useDefault ? this.translate.instant(fallbackKey) : label;
  }

  //Extract the display name of the field for account-account/contact-contact affiliation
  public getCustomDisplayNameFromField(control, formType: any) {
    const refEntityName = control?.subgrid?.referencingEntity ?? control?.subgrid?.targetEntityType;
    const affiliationsRefNames = [
      ACCOUNT_ACCOUNT_AFFILIATIONS_REF_ENTITY, CONTACT_CONTACT_AFFILIATIONS_REF_ENTITY,
      ACCOUNT_ACCOUNT_AFFILIATIONS_CR_REF_ENTITY, CONTACT_CONTACT_AFFILIATIONS_CR_REF_ENTITY,
    ];
    const crAffiliationsRefNames = [ ACCOUNT_ACCOUNT_AFFILIATIONS_CR_REF_ENTITY, CONTACT_CONTACT_AFFILIATIONS_CR_REF_ENTITY ];
    const isAffiliationsData = affiliationsRefNames.includes(refEntityName);
    if (!isAffiliationsData) return;

    const isCrAffiliationsData = crAffiliationsRefNames.includes(refEntityName);
    
    if (!isCrAffiliationsData) {
      //A-A-Affiliation in account form
      if (refEntityName == ACCOUNT_ACCOUNT_AFFILIATIONS_REF_ENTITY) {
        if (control.subgrid.subgridLayout) {
          control.subgrid.subgridLayout.forEach(attrib => {
            if (attrib.attribute == ACCOUNT_ACCOUNT_TO_FILTER_ATTRIBUTE_NAME) {
              this.accountAffiliatedFromLabelText = this.resolveAffiliationLabel(attrib.displayNames, formType, 'AFFILIATED_FROM', 'Affiliated From');
            } else if (attrib.attribute == ACCOUNT_ACCOUNT_FROM_FILTER_ATTRIBUTE_NAME) {
              this.accountAffiliatedToLabelText = this.resolveAffiliationLabel(attrib.displayNames, formType, 'AFFILIATED_TO', 'Affiliated To');
            }
          });
        }
      }
      //C-C-Affiliation in contact form
      else if (refEntityName == CONTACT_CONTACT_AFFILIATIONS_REF_ENTITY) {
        if (control.subgrid.subgridLayout) {
          control.subgrid.subgridLayout.forEach(attrib => {
            if (attrib.attribute == CONTACT_CONTACT_TO_FILTER_ATTRIBUTE_NAME) {
              this.contactAffiliatedFromLabelText = this.resolveAffiliationLabel(attrib.displayNames, formType, 'RELATED_FROM');
            } else if (attrib.attribute == CONTACT_CONTACT_FROM_FILTER_ATTRIBUTE_NAME) {
              this.contactAffiliatedToLabelText = this.resolveAffiliationLabel(attrib.displayNames, formType, 'RELATED_TO');
            }
          });
        }
      }
    } else {
      //A-A-Affiliation in account CR form
      if (refEntityName == ACCOUNT_ACCOUNT_AFFILIATIONS_CR_REF_ENTITY) {
        if (control.subgrid.subgridLayout) {
          control.subgrid.subgridLayout.forEach(attrib => {
            if (attrib.attribute == ACCOUNT_ACCOUNT_TO_CR_ATTRIBUTE_NAME) {
              this.accountCrAffiliatedFromLabelText = this.resolveAffiliationLabel(attrib.displayNames, formType, 'AFFILIATED_FROM', 'Affiliated From');
            } else if (attrib.attribute == ACCOUNT_ACCOUNT_FROM_CR_ATTRIBUTE_NAME) {
              this.accountCrAffiliatedToLabelText = this.resolveAffiliationLabel(attrib.displayNames, formType, 'AFFILIATED_TO', 'Affiliated To');
            }
          });
        }
      }
      //C-C-Affiliation in contact CR form
      else if (refEntityName == CONTACT_CONTACT_AFFILIATIONS_CR_REF_ENTITY) {
        if (control.subgrid.subgridLayout) {
          control.subgrid.subgridLayout.forEach(attrib => {
            if (attrib.attribute == CONTACT_CONTACT_TO_CR_ATTRIBUTE_NAME) {
              this.contactCrAffiliatedFromLabelText = this.resolveAffiliationLabel(attrib.displayNames, formType, 'RELATED_FROM');
            } else if (attrib.attribute == CONTACT_CONTACT_FROM_CR_ATTRIBUTE_NAME) {
              this.contactCrAffiliatedToLabelText = this.resolveAffiliationLabel(attrib.displayNames, formType, 'RELATED_TO');
            }
          });
        }
      }
    }
  }
  public getDisplayText(dtArray: DisplayText[],langCode:string = '1033'): string {
    //default to English as custom label, translation is not supported due to custom input value
    if (!dtArray) return "";
    let displayText: string;
    let en = dtArray.find(value => value.languagecode == langCode);
    if (en) {
      displayText = langCode == '0000' ? this.translate.instant(en.description) : en.description
    } else {
      displayText = "";
    }
    return displayText;
  }
  /**
   * Convert formatted text - Characters with strokes, and diacritics matching
   * lodash _deburr string by converting Latin-1 Supplement and Latin Extended-A letters to basic Latin letters and removing combining diacritical marks.
   */
   public convertFormattedString(targetText: string): string {
    let formattedText: string = targetText;
    formattedText = deburr(targetText);
    // ToDo: If necessary, add unsupported parts for characters with strokes and diacritics
    // you can add characters that are not supported here
    const charactersList = [{raw:'–',converted:'-'}];
    if(formattedText.includes("–")) {
      charactersList.forEach(c => {
        const index = charactersList.findIndex(item => formattedText.includes(item.raw));
        if(index > -1) {
          formattedText = formattedText.replace(new RegExp(escapeRegExp(charactersList[index].raw), 'g'), charactersList[index].converted);
        }
      });
    }
    return formattedText;
  }
  /** Jumbled search - extract 3 letters from words */
  private _getJumbledSearchFetchXMLandWords(formattedSearchText: string, lookupEntityPrimaryName: string): any {
    let searchTextSplitWords = formattedSearchText.split(" ").filter(sw => {return sw !=''});
    searchTextSplitWords.forEach(sw => {
      if(sw.length > 3) {
        let jumbledText = '';
        const searchTextSplit = sw.split("");
        searchTextSplit.forEach((c, idx)=> {
          if(c && idx < sw.length - 2) {
            jumbledText = sw.substring(idx, idx + 3);
            if(jumbledText) searchTextSplitWords.push(jumbledText);
          }
        });
      }
    });
    let jumbledSearchFetchXML = ''
    searchTextSplitWords.forEach(sw => {
      sw = escape(sw);
      jumbledSearchFetchXML += `<condition attribute="${lookupEntityPrimaryName}" operator="like" value="%${sw}%" />`
    });
    return {searchFilterFetchXML: jumbledSearchFetchXML, searchWords: searchTextSplitWords};
  }
  /** Clear onekeycode from lookup data */
  public clearMappedLookupOnekeyWithId(targetId: string) {
    const okIdx = this.okLookUpMapper.findIndex(ld => {return ld.guid && ld.guid == targetId;});
    if(okIdx >= 0) {
      this.okLookUpMapper.splice(okIdx,1);
    }
  }
  public clearMappedLookupOnekeyWithName(schemaName: string) {
    const okIdx = this.okLookUpMapper.findIndex(ld => {return ld.entity && ld.entity == schemaName;});
    if(okIdx >= 0) {
      this.okLookUpMapper.splice(okIdx,1);
    }
  }
  /** Add onekeycode to lookup data */
  public addLookupOnekeyData(targetId: string, crLookUp: any) {
    const okIdx = this.okLookUpMapper.findIndex(ld => {return ld.guid && ld.guid == targetId;});
    if(okIdx >= 0) {
      this.okLookUpMapper[okIdx] = crLookUp;
    } else {
      this.okLookUpMapper.push(crLookUp);
    }
  }

  /*************Edit business information in offline - Non-OneKey contacts*************/
  public async populateLookupFieldsDataForDynamicForms(loadFromDbOnly = false){
    //*Pending to add check for fields configured from Dynamic Forms *//

    /**
     * To check for Feature Action related to Contact Edit and then fetch All lookup fields for
      1.Edit a contact in Offline mode
      2.Edit Business CR in Offline mode
      3.Create OneKey CR in Offline mode
    */
    if(this.authenticationService.hasFeatureAction(FeatureActionsMap.CONTACT_EDITOR)
    || (this.authenticationService.hasFeatureAction(FeatureActionsMap.CONTACTS_CREATE_REQUEST)
    && this.authenticationService.hasFeatureAction(FeatureActionsMap.CONTACTS_ONEKEY_SELECTION))) {
      await this.getAllLookupFieldsDataForOfflineContactEdit(loadFromDbOnly);
    }
  }

  private async getAllLookupFieldsDataForOfflineContactEdit(loadFromDbOnly = false) {
    if(loadFromDbOnly){
      await this.disk.retrieve(DB_KEY_PREFIXES.DYNAMIC_FORMS_ALL_LOOKUP_FIELDS, true).then((doc)=>{
        if(doc && doc.raw){
          this.allLookUpFieldsForOfflineEdit = doc.raw;
        }
        else {
          this.allLookUpFieldsForOfflineEdit = {};
        }
      })
      return;
    }
    try {
      const lookupFields = await this.getAllLookupFieldsForOfflineContactEdit();
      let allLookUpFieldsForOfflineContactEdit = {};

      const query = '';
      const filter = '';
      const changeRequest = false;

      for (let i = 0; i < lookupFields.length; i++) {
        const lookupField = lookupFields[i];
        if(lookupField.lookupQueries && lookupField.attributeName) {
          const results = await this.getLookupResults(query, lookupField, filter, changeRequest);

          //Storing the results in the form of Key-Value pair
          allLookUpFieldsForOfflineContactEdit[lookupField.attributeName] = results;
        }
      }

      this.allLookUpFieldsForOfflineEdit = allLookUpFieldsForOfflineContactEdit;

      console.warn(`getAllLookupFieldsDataForOfflineContactEdit`);
      for (const key in this.allLookUpFieldsForOfflineEdit) {
        if (this.allLookUpFieldsForOfflineEdit.hasOwnProperty(key)) {
            console.log(`${key} : ${this.allLookUpFieldsForOfflineEdit[key].length}`);
            // console.warn(this.allLookUpFieldsForOfflineEdit[key]);
        }
      }

      this.disk.updateOrInsert(DB_KEY_PREFIXES.DYNAMIC_FORMS_ALL_LOOKUP_FIELDS, (doc)=>{
        doc = {
            raw: []
        };
        doc.raw = this.allLookUpFieldsForOfflineEdit;
        return doc;
      })
    } catch (error) {
      console.log('lookup fields data for offline contact edit - service failed', error)
    }
  }

  /**
   * Hydrate picklist controls on a medical inquiry form with cached option sets (for offline).
   * Mutates form.metadata[].controls where dataType is PicklistType/MultiSelectPicklistType and optionSet is empty.
   */
  hydrateMedicalInquiryFormOptionSets(form: DynamicForm, cachedOptions: Record<string, Option[]>): void {
    const hasForm = !!(form && form.metadata);
    const hasCached = !!(cachedOptions && Object.keys(cachedOptions).length);
    console.log('[MI optionsets] hydrateMedicalInquiryFormOptionSets: hasForm=', hasForm, 'metadata tabs=', form?.metadata?.length ?? 0, 'cachedOptions keys=', cachedOptions ? Object.keys(cachedOptions).length : 0, 'cachedKeys=', cachedOptions ? Object.keys(cachedOptions) : []);
    if (!form || !form.metadata || !cachedOptions || !Object.keys(cachedOptions).length) return;
    let hydratedCount = 0;
    for (const tab of form.metadata) {
      if (!tab.controls || !tab.controls.length) continue;
      for (const control of tab.controls) {
        const isPicklist = control.dataType === ControlDataType.PicklistType || control.dataType === ControlDataType.MultiSelectPicklistType;
        if (isPicklist && (!control.optionSet || !control.optionSet.length)) {
          const name = control.optionSetName || control.attributeName;
          const options = (name && cachedOptions[name]) ? cachedOptions[name] : [];
          control.optionSet = options;
          if (options.length) hydratedCount++;
          else console.log('[MI optionsets] hydrateMedicalInquiryFormOptionSets: no cache for control name=', name, 'attributeName=', control.attributeName);
        }
      }
    }
    console.log('[MI optionsets] hydrateMedicalInquiryFormOptionSets: hydrated controls count=', hydratedCount);
  }

  /**
   * Load option sets for medical inquiry form from DB (offline). Uses in-memory cache (miFormOptionSets) when
   * already populated (e.g. by preload from list). Falls back to PouchDB and caches result for next time.
   */
  async getMIFormOptionSetsFromDb(): Promise<Record<string, Option[]>> {
    if (Object.keys(this.miFormOptionSets).length > 0) {
      return this.miFormOptionSets;
    }
    const doc = await this.disk.retrieve(DB_KEY_PREFIXES.MEDICAL_INQUIRY_FORM_OPTION_SETS, true);
    const result = (doc && doc.raw && typeof doc.raw === 'object') ? doc.raw : {};
    this.miFormOptionSets = result;
    console.log('[MI optionsets] getMIFormOptionSetsFromDb: doc present=', !!doc, 'raw present=', !!(doc && doc.raw), 'keys count=', Object.keys(result).length, 'keys=', Object.keys(result));
    return result;
  }

  /**
   * Sync global option sets for medical inquiry form (picklist fields that have only OptionSetName, no embedded Options).
   * When loadFromDbOnly is true, loads from PouchDB into miFormOptionSets and returns. Otherwise fetches from API and persists.
   */
  async syncOptionSetsForMedicalInquiry(loadFromDbOnly = false): Promise<void> {
    console.log('[MI optionsets] syncOptionSetsForMedicalInquiry: loadFromDbOnly=', loadFromDbOnly);
    if (loadFromDbOnly) {
      const doc = await this.disk.retrieve(DB_KEY_PREFIXES.MEDICAL_INQUIRY_FORM_OPTION_SETS, true);
      this.miFormOptionSets = (doc && doc.raw && typeof doc.raw === 'object') ? doc.raw : {};
      console.log('[MI optionsets] syncOptionSetsForMedicalInquiry (loadFromDb): doc present=', !!doc, 'miFormOptionSets keys=', Object.keys(this.miFormOptionSets).length, 'keys=', Object.keys(this.miFormOptionSets));
      return;
    }

    try {
      const createForm = this.getFormDefinitionForEntity('indskr_medicalinquiry', FormType.CREATEFORM);
      const editForm = this.getFormDefinitionForEntity('indskr_medicalinquiry', FormType.EDITFORM);
      const forms = [createForm, editForm].filter(Boolean);
      console.log('[MI optionsets] syncOptionSetsForMedicalInquiry (sync): createForm=', !!createForm, 'editForm=', !!editForm);

      // Controls whose options must be fetched from the global option-set API.
      const optionSetNamesToFetch = new Set<string>();
      // Seed the map with options already embedded in form controls (StateType/StatusType options are
      // entity-specific and cannot be fetched via getOptionSet, so embedded is the only source).
      const map: Record<string, Option[]> = {};

      for (const form of forms) {
        if (!form.metadata || !form.metadata.length) continue;
        for (const tab of form.metadata) {
          if (!tab.controls || !tab.controls.length) continue;
          for (const control of tab.controls) {
            const isOptionSetType =
              control.dataType === ControlDataType.PicklistType ||
              control.dataType === ControlDataType.MultiSelectPicklistType ||
              control.dataType === ControlDataType.StateType ||
              control.dataType === ControlDataType.StatusType;
            if (!isOptionSetType) continue;
            const name = control.optionSetName || control.attributeName;
            if (!name) continue;
            if (control.optionSet && control.optionSet.length) {
              // Embedded options: persist directly — no API call needed.
              if (!map[name]) map[name] = control.optionSet;
            } else if (
              control.dataType === ControlDataType.PicklistType ||
              control.dataType === ControlDataType.MultiSelectPicklistType
            ) {
              // No embedded options and it's a global picklist → fetch from API.
              optionSetNamesToFetch.add(name);
            }
          }
        }
      }
      console.log('[MI optionsets] syncOptionSetsForMedicalInquiry (sync): embedded keys=', Object.keys(map), 'toFetch=', [...optionSetNamesToFetch]);

      for (const name of optionSetNamesToFetch) {
        if (map[name]) continue; // already have embedded options for this name
        const options = await this.getOptionSet(name);
        if (options && options.length) map[name] = options;
        else console.log('[MI optionsets] syncOptionSetsForMedicalInquiry (sync): no options for name=', name);
      }
      console.log('[MI optionsets] syncOptionSetsForMedicalInquiry (sync): map keys=', Object.keys(map).length, 'persisting to DB');

      this.miFormOptionSets = map;
      await this.disk.updateOrInsert(DB_KEY_PREFIXES.MEDICAL_INQUIRY_FORM_OPTION_SETS, () => ({ raw: map }));
    } catch (error) {
      console.error('syncOptionSetsForMedicalInquiry failed', error);
    }
  }

  /**
   * Load lookup fields cache for medical inquiry form from DB only. Used when device is offline or on init.
   */
  async getMIFormLookupFieldsFromDb(): Promise<Record<string, LookupSearchResult[]>> {
    const doc = await this.disk.retrieve(DB_KEY_PREFIXES.MEDICAL_INQUIRY_FORM_LOOKUP_FIELDS, true);
    return (doc?.raw && typeof doc.raw === 'object') ? doc.raw : {};
  }

  /** Returns in-memory cache of MI form lookup field results for offline use. */
  getMIFormLookupFields(): Record<string, LookupSearchResult[]> {
    return this.miFormLookupFields;
  }

  /**
   * Enrich medical inquiry rawData with FormattedValue for optionset and lookup fields so display/edit forms
   * show labels when offline (API normally provides these keys). Uses cached option sets and MI lookup cache.
   * Does not mutate the input; returns a new object.
   */
  async enrichMedicalInquiryRawDataForDisplay(rawData: Record<string, unknown>): Promise<Record<string, unknown>> {
    if (!rawData || typeof rawData !== 'object' || Array.isArray(rawData)) {
      return rawData ?? {};
    }
    const displayForm = this.getFormDefinitionForEntity('indskr_medicalinquiry', FormType.DISPLAYFORM);
    if (!displayForm?.metadata?.length) {
      return { ...rawData };
    }
    const [cachedOptions, lookupCache] = await Promise.all([
      this.getMIFormOptionSetsFromDb(),
      this.getMIFormLookupFieldsFromDb(),
    ]);
    const langCode = (this.localizationService?.selectedLanguage?.localeID as string) || '1033';
    const enriched = { ...rawData };

    // Offline-saved payload has lookups in lookupfields[]; display form expects _attr_value. Flatten so resolution can run.
    const lookupfields = rawData.lookupfields;
    if (Array.isArray(lookupfields)) {
      for (const item of lookupfields) {
        if (item && typeof item === 'object' && (item as any).name && (item as any).id) {
          const attrKey = '_' + String((item as any).name).toLowerCase() + '_value';
          if (enriched[attrKey] === undefined || enriched[attrKey] === '') {
            (enriched as Record<string, unknown>)[attrKey] = (item as any).id;
          }
        }
      }
    }

    for (const tab of displayForm.metadata) {
      if (!tab.controls?.length) continue;
      for (const control of tab.controls) {
        const attr = control.attributeName;
        if (!attr) continue;

        if (control.dataType === ControlDataType.PicklistType) {
          const value = enriched[attr];
          const formattedKey = attr + '@OData.Community.Display.V1.FormattedValue';
          if ((value !== undefined && value !== null && value !== '') || value === 0) {
            if (enriched[formattedKey] === undefined || enriched[formattedKey] === '') {
              const optionSetName = control.optionSetName || attr;
              // Fall back to the control's own embedded options when the DB cache is empty (e.g. options
              // were embedded in the form definition and never fetched separately from the API).
              const options = cachedOptions[optionSetName] || control.optionSet;
              const option = options?.find((o: Option) => o.value === Number(value));
              const label = option?.displayNames?.find((d: { languagecode: string }) => d.languagecode === langCode)?.description
                || option?.displayNames?.find((d: { languagecode: string }) => d.languagecode === '1033')?.description
                || option?.displayNames?.[0]?.description;
              if (label) (enriched as Record<string, unknown>)[formattedKey] = label;
            }
          }
          continue;
        }

        if (control.dataType === ControlDataType.MultiSelectPicklistType) {
          const value = enriched[attr];
          const formattedKey = attr + '@OData.Community.Display.V1.FormattedValue';
          if (value !== undefined && value !== null && value !== '') {
            if (enriched[formattedKey] === undefined || enriched[formattedKey] === '') {
              const optionSetName = control.optionSetName || attr;
              const options = cachedOptions[optionSetName] || control.optionSet;
              const values = typeof value === 'string' ? value.split(/\s*[,;]\s*/).map(v => Number(v.trim())) : (Array.isArray(value) ? value.map(Number) : [Number(value)]);
              const labels: string[] = [];
              for (const v of values) {
                const option = options?.find((o: Option) => o.value === v);
                const label = option?.displayNames?.find((d: { languagecode: string }) => d.languagecode === langCode)?.description
                  || option?.displayNames?.find((d: { languagecode: string }) => d.languagecode === '1033')?.description
                  || option?.displayNames?.[0]?.description;
                if (label) labels.push(label);
              }
              if (labels.length) (enriched as Record<string, unknown>)[formattedKey] = labels.join('; ');
            }
          }
          continue;
        }

        if (control.dataType === ControlDataType.StateType || control.dataType === ControlDataType.StatusType) {
          const value = enriched[attr];
          const formattedKey = attr + '@OData.Community.Display.V1.FormattedValue';
          if ((value !== undefined && value !== null && value !== '') || value === 0) {
            if (enriched[formattedKey] === undefined || enriched[formattedKey] === '') {
              const optionSetName = control.optionSetName || attr;
              // StateType/StatusType options are entity-specific (not global option sets), so the DB
              // cache is populated from embedded form control options. Fall back to control.optionSet
              // as a safety net when the cache entry is missing.
              const options = cachedOptions[optionSetName] || control.optionSet;
              const option = options?.find((o: Option) => o.value === Number(value));
              const label = option?.displayNames?.find((d: { languagecode: string }) => d.languagecode === langCode)?.description
                || option?.displayNames?.find((d: { languagecode: string }) => d.languagecode === '1033')?.description
                || option?.displayNames?.[0]?.description;
              if (label) (enriched as Record<string, unknown>)[formattedKey] = label;
            }
          }
          continue;
        }

        if (control.dataType === ControlDataType.LookupType) {
          const valueKey = '_' + attr + '_value';
          const formattedKey = valueKey + '@OData.Community.Display.V1.FormattedValue';
          const lookupId = enriched[valueKey];
          if (lookupId && (enriched[formattedKey] === undefined || enriched[formattedKey] === '')) {
            const results = lookupCache[attr];
            const found = Array.isArray(results) ? results.find((r: LookupSearchResult) => r.id === lookupId) : null;
            if (found?.name) (enriched as Record<string, unknown>)[formattedKey] = found.name;
          }
        }
      }
    }
    return enriched;
  }

  /**
   * Sync lookup field values for MI form (entities not already in PouchDB). When loadFromDbOnly is true,
   * loads from PouchDB into miFormLookupFields. Otherwise walks CREATEFORM + EDITFORM, fetches lookup results, persists.
   */
  async syncLookupFieldsForMedicalInquiry(loadFromDbOnly = false): Promise<void> {
    if (loadFromDbOnly) {
      const doc = await this.disk.retrieve(DB_KEY_PREFIXES.MEDICAL_INQUIRY_FORM_LOOKUP_FIELDS, true);
      this.miFormLookupFields = (doc?.raw && typeof doc.raw === 'object') ? doc.raw : {};
      return;
    }

    try {
      const createForm = this.getFormDefinitionForEntity('indskr_medicalinquiry', FormType.CREATEFORM);
      const editForm = this.getFormDefinitionForEntity('indskr_medicalinquiry', FormType.EDITFORM);
      const forms = [createForm, editForm].filter(Boolean);

      const seenAttributes = new Set<string>();
      const lookupControls: Control[] = [];
      for (const form of forms) {
        if (!form.metadata?.length) continue;
        for (const tab of form.metadata) {
          if (!tab.controls?.length) continue;
          for (const control of tab.controls) {
            const isLookup = control.dataType === ControlDataType.LookupType
              && control.lookupQueries?.fetchXml
              && control.attributeName;
            const skipEntity = control.lookupEntitySetName && DynamicFormsService.SKIP_ENTITIES.has(control.lookupEntitySetName);
            if (isLookup && !skipEntity && !seenAttributes.has(control.attributeName)) {
              seenAttributes.add(control.attributeName);
              lookupControls.push(control);
            }
          }
        }
      }

      const map: Record<string, LookupSearchResult[]> = {};
      for (const control of lookupControls) {
        let savedFetchXml: string | undefined;
        if (control.filterFieldTargetLookupEntity && control.lookupQueries?.fetchXml) {
          const targetAttr = control.filterFieldTargetLookupEntity;
          // Skip injection if the org's own lookup view already covers this attribute - either
          // explicitly (duplicate <attribute> tags) or via <all-attributes/>, which Dataverse
          // rejects when combined with an explicit <attribute> in the same entity.
          const alreadyHasAllAttributes = /<all-attributes\s*\/>/i.test(control.lookupQueries.fetchXml);
          const alreadyHasAttribute = new RegExp(`<attribute\\s+name=["']${targetAttr}["']`, 'i').test(control.lookupQueries.fetchXml);
          if (!alreadyHasAllAttributes && !alreadyHasAttribute) {
            savedFetchXml = control.lookupQueries.fetchXml;
            control.lookupQueries.fetchXml = control.lookupQueries.fetchXml.replace(
              /(<entity\b[^>]*>)/,
              `$1<attribute name="${targetAttr}" />`
            );
          }
        }
        const results = await this.getLookupResults('', control, '', false);
        if (savedFetchXml !== undefined) {
          control.lookupQueries.fetchXml = savedFetchXml;
        }
        map[control.attributeName] = Array.isArray(results) ? results : [];
      }

      await this.disk.updateOrInsert(DB_KEY_PREFIXES.MEDICAL_INQUIRY_FORM_LOOKUP_FIELDS, () => ({ raw: map }));
      this.miFormLookupFields = map;
    } catch (error) {
      console.error('syncLookupFieldsForMedicalInquiry failed', error);
    }
  }

  /*************Edit business information in offline - Non-OneKey contacts*************/
  public async getAllLookupFieldsForOfflineContactEdit():Promise<any> {
    let lookupFields = [];
    let entities = ['contact','contactcr','indskr_contactcr'];

    const collectLookupFieldsFromForm = async (form: DynamicForm) => {
      if (!form?.metadata?.length) return;
      for (const tab of form.metadata) {
        if (!tab?.controls?.length) continue;
        for (const control of tab.controls) {
          if (control.dataType == ControlDataType.LookupType) {
            lookupFields.push(control);
          } else if (control.dataType == null && control['linkedEntityConfig']) {
            const foundForm = this.getFormDefinitionForEntity(control['linkedEntityConfig']['entityName'], FormType.CREATEFORM);
            if (foundForm?.metadata?.length) {
              for (const linkedTab of foundForm.metadata) {
                if (!linkedTab?.controls?.length) continue;
                for (const linkedControl of linkedTab.controls) {
                  if (linkedControl.dataType == ControlDataType.LookupType) {
                    lookupFields.push(linkedControl);
                  }
                }
              }
            }
          }
        }
      }
    };

    // Fetch EDITFORM for generic entities (non-OneKey contact edit / business CR offline)
    return await Promise.all ([
        entities.forEach(async (entityName) => {
          let contactForm: DynamicForm = await this.getFormDefinitionForEntity(entityName, FormType.EDITFORM);
          if(!contactForm){
            contactForm = new DynamicForm(DEFAULT_CONTACT_CREATE_FORM['value'][0]);
          }
          await collectLookupFieldsFromForm(contactForm);
        })//end of entities.forEach
    ]).then(async () => {
      // Also fetch OneKey / SanofiChina CREATEFORM lookup fields (OMNI-60493: omnione_lu_* attrs differ from indskr_lu_*)
      const oneKeyCreateForm = this.getFormDefinitionForEntity('indskr_contactcr', FormType.CREATEFORM, BusinessProcessType.OneKey);
      const sanofiChinaCreateForm = this.getFormDefinitionForEntity('indskr_contactcr', FormType.CREATEFORM, BusinessProcessType.SanofiChina);
      const oneKeyEditForm = this.getFormDefinitionForEntity('indskr_contactcr', FormType.EDITFORM, BusinessProcessType.OneKey);
      await collectLookupFieldsFromForm(oneKeyCreateForm);
      await collectLookupFieldsFromForm(sanofiChinaCreateForm);
      await collectLookupFieldsFromForm(oneKeyEditForm);

      // Omnipresence: directly filter dynamicForms to avoid toast when multiple forms exist for same BP
      const omnipresenceForms = this.dynamicForms.filter(f =>
        f.indskr_entityname === 'indskr_contactcr' &&
        f.indskr_businessprocess === BusinessProcessType.Omnipresence &&
        (f.indskr_formtype === FormType.EDITFORM || f.indskr_formtype === FormType.CREATEFORM)
      );
      for (const formDef of omnipresenceForms) {
        await collectLookupFieldsFromForm(new DynamicForm(formDef));
      }

      let lookupFieldsToRemove = ['indskr_accountid','indskr_contactid'];
      //To remove Unwanted lookups fields from Offline storage
      return lookupFields = lookupFields.filter(item => !lookupFieldsToRemove.includes(item.attributeName));
    });
  }

  public getInputTextForFormField(control: Control,raw:any): string {
    if (!raw) return;
    try {
      if (control && control.dataType) {
        switch (control.dataType) {
          case ControlDataType.StringType:
          case ControlDataType.MoneyType:
          case ControlDataType.IntegerType:
          case ControlDataType.DecimalType:
          case ControlDataType.DoubleType:
          case ControlDataType.MemoType:
            return raw[control.attributeName]?raw[control.attributeName]:'';
          case ControlDataType.OwnerType:
          case ControlDataType.LookupType:
            if(control.lookupEntityPrimaryId && control.lookupEntityPrimaryId == "omnione_onekeycodeslabelsid"){
              if(raw['_' + control.attributeName  + '_value'] && this.localizationService.multiLingualFieldsData && this.localizationService.multiLingualFieldsData.length > 0){
                let foundRecord = this.localizationService.multiLingualFieldsData.find(a=> a['omnione_onekeycodeslabelsid'] == raw['_' + control.attributeName  + '_value']);
                let translatedLang: string = '';
                let key = this.localizationService.getOneKeyTableAttributes();
                if(foundRecord) translatedLang = foundRecord[key] ? foundRecord[key] || '' : foundRecord['omnione_en_long_label'] || '';
                if(foundRecord && foundRecord['omnione_onekeycodeslabelsid'] && translatedLang){
                  return translatedLang?translatedLang:'';
                }
              }
            }else if (raw['_' + control.attributeName + '_value']) {
              return raw['_' + control.attributeName + '_value@OData.Community.Display.V1.FormattedValue'] ? raw['_' + control.attributeName + '_value@OData.Community.Display.V1.FormattedValue'] : '';
            }
            else {
              return '';
            }
          case ControlDataType.BooleanType:
            return (raw && raw.hasOwnProperty(control.attributeName)) ? (raw[control.attributeName] ? this.translate.instant('YES') : this.translate.instant('NO')) : '';
          case ControlDataType.StateType:
          case ControlDataType.StatusType:
            if (raw[control.attributeName] || raw[control.attributeName] == 0) {
              let str = raw[control.attributeName + '@OData.Community.Display.V1.FormattedValue'];
              return str ? str : '';
            }
            else {
              return '';
            }
          case ControlDataType.MultiSelectPicklistType:
            if (raw[control.attributeName]) {
              let str = raw[control.attributeName + '@OData.Community.Display.V1.FormattedValue'].replace(/;/g, ',');
              return str ? str : '';
            }
            else {
              return '';
            }
          case ControlDataType.PicklistType:
            if (raw[control.attributeName]) {
              return raw[control.attributeName + '@OData.Community.Display.V1.FormattedValue'] ? raw[control.attributeName + '@OData.Community.Display.V1.FormattedValue'] : '';
            }
            else {
              return '';
            }
          case ControlDataType.DateTimeType:
            if (raw[control.attributeName] || raw[control.attributeName + '@OData.Community.Display.V1.FormattedValue']) {
              let date: Date;
              if (raw[control.attributeName]) {
                date = new Date(raw[control.attributeName]);
                if (!this.dateTimeFormatsService.isValidDate(date)) {
                  date = new Date(parseInt(raw[control.attributeName]));
                  if (!this.dateTimeFormatsService.isValidDate(date) && raw[control.attributeName + '@OData.Community.Display.V1.FormattedValue']) {
                    date = new Date(raw[control.attributeName + '@OData.Community.Display.V1.FormattedValue']);
                  }
                }
              } else if (raw[control.attributeName + '@OData.Community.Display.V1.FormattedValue']) {
                  date = new Date(raw[control.attributeName + '@OData.Community.Display.V1.FormattedValue']);
              }
              if (this.dateTimeFormatsService.isValidDate(date)) {
                if (control.attributeName =='omnione_yearofbirth') {
                  return this.dateTimeFormatsService.formatDate(date, 'YYYY');
                } else if(control.attributeName =='omnione_dayandmonthofbirth'){
                  return this.dateTimeFormatsService.formatDate(date);
                }
              } else {
                return '';
              }
            } else {
              return '';
            }
          default:
            return '';
        }
      } else {
        return '';
      }
    } catch (error) {
      console.log("Error occured while parsing quick glance option values"+ error);
    }
  }

  //Fetch Business Rules
   private async getBusineesRulesForMobileAppForms(data){
    let formIds:Array<string> = []; 
    let formIdsString:string = '';
    try {
      if(data && data.length > 0){
        data.forEach(form => {
          if(form && form['indskr_formid']){
            let formId = form['indskr_formid'].substring(form['indskr_formid'].indexOf('(')+1,form['indskr_formid'].length-1);
            if(formId && !formIds.includes(formId)){
              formIds.push(formId);
              formIdsString+= `<value>${formId}</value>\n`
            }
          }
        });
        formIdsString = formIdsString.substring(0, formIdsString.length - 1);
        let fetchXML = MOBILE_FORMS_BUSINESS_RULES;
        fetchXML = fetchXML.replace('{FormIDS}', formIdsString);
        const businessRulesData = await this.dynamics.executeFetchQuery('workflows', fetchXML);
        if(businessRulesData && businessRulesData.length > 0){
          businessRulesData.forEach(rule=> {
            if(rule && rule['processtriggerformid']){
              let forms = data.filter(a=> a['indskr_formid'].includes(rule['processtriggerformid']));
                if(forms && forms.length > 0){{
                  forms.forEach(form=>{
                    if(form['businessRules']){
                      form['businessRules'].push(rule);
                    }else{
                      form['businessRules'] = [rule];
                    }
                  })
                }
              }
            }
          })
        }
      }
    } catch (error) {
      console.log(error);
    }
   }

   public async runBussinessRulesForLinkedEntity(subgridLayout,entityName,rawData){
    let foundForm:DynamicForm = this.getFormDefinitionForEntity(entityName,FormType.DISPLAYFORM);
    if(foundForm && foundForm.businessRules){
      this.currentLinkedEntityName = entityName+'.';
      this.currentLinkedEntityForm = foundForm;
      this.currentLinkedEntityRawData = rawData;
      this.currentLinkedEntitySubgridLayout = subgridLayout;
      this.currentLinkedEntitySubgridLayout.forEach(a=> {a['isVisible'] = true} );
      this.subgridLayoutChangeAfterBusinessRules = false;
      const businessRules = foundForm && foundForm.businessRules ? foundForm.businessRules : [];
      const functionMap: Array<Function> = [];

      // Create a map of function names to actual functions
      businessRules.forEach((funcString) => {
        try {
          if(funcString && funcString.logicFunction){
            funcString.logicFunction = funcString.logicFunction.replace('(eventContext)','(eventContext,Mscrm,Xrm)')
            const func = new Function('return ' + funcString.logicFunction)();
            if (func) {
              functionMap.push(func);
            }
          }
          
        } catch (error) {
          console.error(`Error parsing function: ${error}`);
        }
      });

      for (const func of functionMap) {
        try {
          const Mscrm = {
            BusinessRules: {
              Utility: {
                isNull: (o) => o == null || o === undefined,
                sanitizeGuid: (guid) => true,
              },
              ErrorHandlerFactory: {
                getHandler: function (e, f) {
                  return {
                    handleError: () => {
                      throw e;
                    },
                  };
                },
              },
            },
          };
          
          const Xrm = {
            Page: {
              data: {
                entity: undefined,
              },
            },
          };
          const eventContext = {
            getFormContext: () => this._getFormContext()
          }
          func(eventContext,Mscrm,Xrm);
        } catch (error) {
          console.error('Error executing function:', error);
        }
      }
      if(this.subgridLayoutChangeAfterBusinessRules){
        subgridLayout = this.currentLinkedEntitySubgridLayout.filter(a=> a['isVisible'] != false );
        this.subgridLayoutChangeAfterBusinessRules = false;
      }
    }
  }

  private _getFormContext(){
    return {
      data: {
        entity: {
          attributes: {
            get: (fieldName) => this._getAttribute(fieldName),
          }
        }
      }
    }
  }

  private _getAttribute(fieldName){
    return {
      getValue: () => this._getAttributeValue(fieldName),
      //setValue: (value) => this._setBusinessRuleAttributeValue(value,fieldName),
      controls: [
        {
          setVisible: (visible) => this._setVisible(visible,fieldName),
          setDisabled: (disabled) => true,//this._setDisabled(disabled,fieldName),
        },
      ],
      setRequiredLevel: (required) => true,//this._setIsRequired(required,fieldName),
    }
  }

  private _getAttributeValue(fieldName){
    let targetControl: Control = this._getTargetControl(fieldName);
    if(targetControl.dataType == ControlDataType.PicklistType){
      if (this.currentLinkedEntityRawData && this.currentLinkedEntityRawData.hasOwnProperty(this.currentLinkedEntityName+targetControl.attributeName)) {
        return parseInt(this.currentLinkedEntityRawData[this.currentLinkedEntityName+targetControl.attributeName]);
      }else{
        return null;
      }
    }
    else {
      return this._getInputTextForFormField(targetControl);
    }
  }

  private _getInputTextForFormField(control: Control): string {
    if (control && control.dataType) {
      switch (control.dataType) {
        case ControlDataType.StringType:
        case ControlDataType.MoneyType:
        case ControlDataType.IntegerType:
        case ControlDataType.DecimalType:
        case ControlDataType.DoubleType:
        case ControlDataType.MemoType:
          return (this.currentLinkedEntityRawData && this.currentLinkedEntityRawData[this.currentLinkedEntityName+control.attributeName]) ? this.currentLinkedEntityRawData[this.currentLinkedEntityName+control.attributeName] : '';
        case ControlDataType.LookupType:
          return (this.currentLinkedEntityRawData && this.currentLinkedEntityRawData[this.currentLinkedEntityName+control.attributeName]) ? this.currentLinkedEntityRawData[this.currentLinkedEntityName+control.attributeName] : '';
        case ControlDataType.BooleanType:
          return (this.currentLinkedEntityRawData && this.currentLinkedEntityRawData.hasOwnProperty(this.currentLinkedEntityName+control.attributeName)) ? (this.currentLinkedEntityRawData[this.currentLinkedEntityName+control.attributeName] ? this.translate.instant('YES') : this.translate.instant('NO')) : '';
        case ControlDataType.StateType:
          return (this.currentLinkedEntityRawData && (this.currentLinkedEntityRawData[this.currentLinkedEntityName+control.attributeName] || this.currentLinkedEntityRawData[this.currentLinkedEntityName+control.attributeName]==0)) ? this.currentLinkedEntityRawData[this.currentLinkedEntityName+control.attributeName] : '';
        case ControlDataType.StatusType:
        case ControlDataType.MultiSelectPicklistType:
        //case ControlDataType.PicklistType:
          //return (this._currentFormValue && this._currentFormValue[control.attributeName] && this._currentFormStringValues && this._currentFormStringValues[control.attributeName]) ? this._currentFormStringValues[control.attributeName] : '';
        case ControlDataType.DateTimeType:
          return (this.currentLinkedEntityRawData && this.currentLinkedEntityRawData[this.currentLinkedEntityName+control.attributeName]) ? this.currentLinkedEntityRawData[this.currentLinkedEntityName+control.attributeName] : '';
        default:
          return '';
      }
    } else {
      return '';
    }
  }

  private _getTargetControl(attrName: string): Control {
    let targetControl: Control
    for (let tabIdx = 0; tabIdx < this.currentLinkedEntityForm.metadata.length; tabIdx++) {
      const tab = this.currentLinkedEntityForm.metadata[tabIdx];
      if (tab && tab.controls && tab.controls.length > 0) {
        let foundControl = tab.controls.find(c => c.attributeName == attrName);
        if (foundControl) {
          targetControl = foundControl;
          break;
        }
      }
    };
    return targetControl;
  }

  private _setVisible(visible, fieldName) {
    if(this.currentLinkedEntitySubgridLayout && this.currentLinkedEntitySubgridLayout.length > 0){
      let idx = this.currentLinkedEntitySubgridLayout.findIndex(a=> a.attribute == fieldName);
      if(idx>= 0){
        this.currentLinkedEntitySubgridLayout[idx]['isVisible'] = visible;
        this.subgridLayoutChangeAfterBusinessRules = true;
      }
    }
    // for (let tabIdx = 0; tabIdx < this.formMetadata.metadata.length; tabIdx++) {
    //   const tab = this.formMetadata.metadata[tabIdx];
    //   if (tab && tab.controls && tab.controls.length > 0) {
    //     let foundControl = tab.controls.find(c => c.attributeName == fieldName);
    //     if (foundControl) {
    //       foundControl.forceHide = !visible;
    //       break;
    //     }
    //   }
    // };
  }

}
